import { environment } from '@app-environments/environment';
export const portal = environment.portal;
export const tenant = environment.tenant;
export const schedulePdfUrl = "https://learn-test-schedule.s3.ap-south-1.amazonaws.com/";

export const NeetTopics = [
  {
    name: 'PHYSICS',
    total: '45',
    startfrom: 45,
    position: 0,
    positionback: 89,
    secACount: 35,
    secBCount: 15,
  },
  {
    name: 'CHEMISTRY',
    total: '45',
    startfrom: 0,
    position: 1,
    positionback: 44,
    secACount: 35,
    secBCount: 15,
  },
  {
    name: 'BIOLOGY',
    total: '90',
    startfrom: 90,
    position: 2,
    positionback: 179,
    secACount: 35,
    secBCount: 15,
  },
];

export const NeetV1Topics = [...NeetTopics];
NeetV1Topics[2] = {
  name: 'BIOLOGY',
  total: '90',
  startfrom: 90,
  position: 2,
  positionback: 179,
  secACount: 70,
  secBCount: 30,
};

export const NeetV2Topics = [...NeetTopics];
NeetV2Topics[2] = {
  name: 'BOTANY',
  total: '90',
  startfrom: 90,
  position: 2,
  positionback: 179,
  secACount: 35,
  secBCount: 15,
};
NeetV2Topics[3] = {
  name: 'ZOOLOGY',
  total: '90',
  startfrom: 90,
  position: 2,
  positionback: 179,
  secACount: 35,
  secBCount: 15,
};

export const JEETopics = [...NeetTopics];
JEETopics[2] = {
  name: 'MATHEMATICS',
  total: '90',
  startfrom: 90,
  position: 2,
  positionback: 179,
  secACount: 35,
  secBCount: 15,
};

export const testSpanFormat =
  /\s*([0-9]{4})-([0-9]{2})-([0-9]{2})\s*([0-9]{1,2}):([0-9]{2}) (am|pm)/i;

export const questionTypes: any = {
  '5f0aed9b-8b11-4653-93bc-65941bf3da3f': 'Integer',
  'ec2f3aec-e64c-11ec-8fea-0242ac120002': 'Numeric',
  'ffc0b3e6-f1c4-45df-a302-918fda45e122': 'MMCQ',
  '756a92df-c249-457b-8ec6-8c11e00b8dcf': 'Matrix',
  '3f82eed7-9e45-404c-be19-f0a98cfcba3b': 'Passage',
  '9619d501-aff3-49a5-9492-76b6a92d61be': 'Subjective',//"Subjective Based very short Answer"
  "1379cd14-65c4-11ed-9022-0242ac120002": 'Subjective',//"Subjective Based Short Answer"
  "2a6fe29c-65c4-11ed-9022-0242ac120002":'Subjective',//"Subjective Based Long Answer"
};

export const RedeemCoins: any = {
  freeze_streak: 'Freeze streak',
  extend_validity: 'Extend validity',
  get_discount: 'Get Discount on subscription',
};

export const testCLassesMap: any = {
  '6': 'CLASSVI',
  '7': 'CLASSVII',
  '8': 'CLASSVIII',
  '9': 'CLASSIX',
  '10': 'CLASSX',
  '11': 'CLASSXI',
  '12': 'CLASSXII',
};
export const roman_numeric: any = {
  VI: '6',
  VII: '7',
  VIII: '8',
  IX: '9',
  X: '10',
  XI: '11',
  XII: '12',
  XIII: '13',
};
export const secACount: any = {
  BIOLOGY: 70,
  BOTANY: 35,
  ZOOLOGY: 35,
  CHEMISTRY: 35,
  PHYSICS: 35,
};
export const secBCount: any = {
  BIOLOGY: 30,
  BOTANY: 15,
  ZOOLOGY: 15,
  CHEMISTRY: 15,
  PHYSICS: 15,
};
export const secBCorrect: any = {
  BIOLOGY: 20,
  BOTANY: 10,
  ZOOLOGY: 10,
  CHEMISTRY: 10,
  PHYSICS: 10,
};

export const monthNamesArr = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const allowedExamNamesILITE = [
  'NEET',
  'JEEMAIN',
  'JEEADVANCED',
  'APTITUDETEST',
  'FOUNDATIONTEST',
  'CBSE',
];

export const testTypeValues = [
  {
    examtype: null,
    name: 'MOCKTEST',
    value: '5f9624f0-098c-41c6-999b-d847c7e4e3a3',
    status: true,
  },
  {
    examtype: null,
    name: 'PREVIOUSYEAR',
    value: '3712e2ca-be34-4b3d-b31c-a645b709348b',
    status: true,
  },
  {
    examtype: null,
    name: 'SCOREAWAT',
    status: true,
    value: 'e34d1d14-6c33-48fd-900e-e8d3cb76da64',
  },
  {
    examtype: null,
    name: 'SCORE Offline',
    status: true,
    value: '1af0b16b-1ca8-4ac5-bf7c-5206f8a3393c',
  },
  {
    examtype: null,
    name: 'TIMEBOUND',
    value: '066697cf-709c-4c67-a0bb-e43feb0043d9',
    status: true,
  },
  {
    examtype: null,
    name: 'CHAPTERTESTS',
    value: '1594d5e6-a9bc-4744-bc9d-da20a0ac31be',
    status: true,
  },
  {
    examtype: null,
    name: 'New NEET Mock Test',
    value: '5d6fcff0-1000-45bb-b62a-d3d2b2bd3189',
    status: true,
  },
  {
    examtype: null,
    name: 'New NEET Timebound',
    value: '51592ef8-8334-479f-8a91-7cfe809b7c04',
    status: true,
  },
  {
    examtype: null,
    name: 'GRANDTEST',
    value: 'a47f9f23-6203-4759-8977-cc7542d85b23',
    status: true,
  },
  {
    examtype: null,
    name: 'SCHOLARSHIPTEST',
    value: 'fc180abf-a9cb-4bea-b30e-28d8442ae3b8',
    status: true,
  },
  {
    examtype: null,
    name: 'ASSIGNMENTS',
    value: 'd84ab774-93c5-4869-8c3a-d9d99390b2c0',
    status: 'true',
  },
  {
    examtype: null,
    name: 'SCORE',
    value: 'd2cfdb3b-61b9-4279-ba8e-731c0999de94',
    status: 'true',
  },
  {
    examtype: null,
    name: 'SCOREMOCKTEST',
    value: '6a08ead7-3fe6-45cf-a454-45cb3a4f37d5',
    status: 'true',
  },
  {
    examtype: null,
    name: '67521',
    status: 'true',
    value: '1bd7bef9-83ad-41b1-9d17-89f77559b997',
  },
  {
    examtype: null,
    name: 'QC for Vendor',
    status: 'true',
    value: '888d4e0c-1847-44e3-96a2-b6e1cda4c68d',
  },
 {
    examtype: null,
    name: 'FREE NEET MOCK TEST',
    status: 'true',
    value: '3d1755e5-6c42-462f-9bc6-626b521b44e1',
  },
  {
    examtype: null,
    name: 'Success Centre Scholarship Test',
    status: 'true',
    value: '42074fa5-6a68-44bd-8eca-459f1e996f85',
  },
  {
    examtype: null,
    name: 'RAPDailyTest',
    status: 'true',
    value: '9edb8ebe-19da-442e-bab6-d03c3de9b1ba',    
  },
  {
    examtype: null,
    name: 'cf03ca38-34e8-11ed-a261-0242ac120002',//RRRDT JEE MAIN
    status: 'true',
    value: 'cf03ca38-34e8-11ed-a261-0242ac120002',
  },
  {
    examtype: null,
    name: 'RAPTimeBound',
    status: 'true',
    value:"94eb35a0-f8ec-4200-8f0e-78de0ebc37db"
  },
  {
    examtype: null,
    name: 'b9f32e18-34e8-11ed-a261-0242ac120002',//RRRTS JEE MAIN
    status: 'true',
    value: 'b9f32e18-34e8-11ed-a261-0242ac120002',    
  },
  {
    examtype: null,
    name: 'subjectivemocktest',
    value: '174bbef2-4195-4f51-8468-cb992be74628',
    status: 'true',
  },
  {
    examtype: null,
    name: '0ed6411c-65be-11ed-9022-0242ac120002', // "CUET Timebound Social",
    value: '0ed6411c-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: '1eda50ee-65be-11ed-9022-0242ac120002', // "CUET Timebound Commerce",
    value: '1eda50ee-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: '337edf2e-65be-11ed-9022-0242ac120002', // "CUET Mock Test Science",
    value: '337edf2e-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: '41d60246-65be-11ed-9022-0242ac120002', // "CUET Mock Test GT & English",
    value: '41d60246-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: '52d43478-65be-11ed-9022-0242ac120002', // "CUET Mock Test Social",
    value: '52d43478-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: '6649791e-65be-11ed-9022-0242ac120002', // "CUET Mock Test Commerce",
    value: '6649791e-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: '71dd90e4-65be-11ed-9022-0242ac120002', // "CUET PYP Science",
    value: '71dd90e4-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: '7dfddc62-65be-11ed-9022-0242ac120002', // "CUET PYP GT & English",
    value: '7dfddc62-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: 'a132a744-65be-11ed-9022-0242ac120002', // "CUET PYP Social",
    value: 'a132a744-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: 'a851d6b8-65bd-11ed-9022-0242ac120002', // "CUET Timebound Science",
    value: 'a851d6b8-65bd-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: 'afa94d8c-65be-11ed-9022-0242ac120002', // "CUET PYP Commerce",
    value: 'afa94d8c-65be-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: 'd0e5c8fa-65bd-11ed-9022-0242ac120002', // "CUET Timebound GT & English",
    value: 'd0e5c8fa-65bd-11ed-9022-0242ac120002',
    status: true,
  },
  {
    examtype: null,
    name: "SCORE23",
    value : "fb842227-15fd-43db-8bdb-899697599f29",
    status: true,
    },
    
    {
    examtype: null,
    name : "SCORE23MOCKTEST",
    value: "cef19053-0026-4893-a004-f709308a0465",
    status: true,
    }
];

//Allowed exam names Capitalized and trimmed of spaces
export const allowedExamNamesCT = {
  '1': ['APTITUDETEST'],
  '2': ['APTITUDETEST'],
  '3': ['APTITUDETEST'],
  '4': ['APTITUDETEST'],
  '5': ['APTITUDETEST'],
  '6': ['CBSE', 'FOUNDATIONTEST', 'SCORE', 'SCAT'],
  '7': ['CBSE', 'FOUNDATIONTEST', 'SCORE', 'SCAT', 'IJSO'],
  '8': ['CBSE', 'FOUNDATIONTEST', 'SCORE', 'SCAT', 'RMO', 'IJSO'],
  '9': ['CBSE', 'NEET', 'JEEMAIN', 'SCORE', 'SCAT', 'RMO', 'IJSO'],
  '10': ['CBSE', 'NEET', 'JEEMAIN', 'SCORE', 'SCAT', 'NTSE', 'RMO'],
  '11': ['CBSE', 'NEET', 'JEEMAIN', 'JEEADVANCED', 'SCORE', 'SCAT'],
  '12': ['CBSE', 'NEET', 'JEEMAIN', 'JEEADVANCED', 'SCORE', 'SCAT', 'CUET'],
  '13': ['NEET', 'JEEMAIN', 'JEEADVANCED', 'SCORE', 'SCAT'],
};

const lefsideMenuItes = [
  'liveclass',
  'selfLearn',
  'selfLearnV2',
  'assessment',
  'doubts',
  // 'mybookmarks',
  'subscriptions',
  'dashboard',
  'myactivity',
];

if (!environment.myActivity) {
  lefsideMenuItes.splice(lefsideMenuItes.indexOf('myactivity'), 1);
}
if(!environment.displaySelfLearnV2){
  lefsideMenuItes.splice(lefsideMenuItes.indexOf('selfLearnV2'), 1);
}else{
  lefsideMenuItes.splice(lefsideMenuItes.indexOf('selfLearn'), 1);
}

const menuItem_no_selflearn_bookmark = [
  'liveclass',
  'assessment',
  'doubts',
  'subscriptions',
  'dashboard',
  // 'CYOP',
];
const menuItem_no_selflearn_bookmark_liveclass = [
  'assessment',
  'doubts',
  'subscriptions',
];
const menuItem_no_selflearn_bookmark_doubts = [
  'liveclass',
  'assessment',
  'subscriptions',
  'dashboard',
  // 'CYOP',
];
const commonExamTypeMenuitems = {
  NEET: lefsideMenuItes,
  JEEMAIN: lefsideMenuItes,
  JEEADVANCED: lefsideMenuItes,
};

export const myactivity = environment.myActivity;
export const upperLeftsideNavigationMenu: any = [
  {
    active: true,
    module: 'dashboard',
    activeIcon: 'assets/img/dashboard/active-menu-icons/home-active-icon.svg',
    nonactiveIcon: 'assets/img/dashboard/menu-icons/home-normal-icon.svg',
    routeUrl: '/dashboard',
    menuName: 'Home',
    class: '',
    allowedUrls: ['dashboard', ''],
  },
  {
    active: true,
    module: 'liveclass',
    activeIcon:
      'assets/img/dashboard/active-menu-icons/liveclass-active-icon.svg',
    nonactiveIcon: 'assets/img/dashboard/menu-icons/liveclass-icon.svg',
    routeUrl: '/dashboard/liveclass',
    menuName: 'Live Classes',
    class: '',
    allowedUrls: [
      'liveclass',
      'masterclasses',
      'classes',
      'my-courses',
      'all-courses',
    ],
  },
  {
    active: true,
    module: 'selfLearn',
    activeIcon: 'assets/img/selfLearn/menu-learn-selected.svg',
    nonactiveIcon: 'assets/img/selfLearn/menu-learn.svg',
    routeUrl: '/dashboard/selfLearn',
    menuName: 'Learn',
    class: 'bookmark-size',
    allowedUrls: ['selfLearn'],
  },
  {
    active: true,
    module: 'selfLearnV2',
    activeIcon: 'assets/img/selfLearn/menu-learn-selected.svg',
    nonactiveIcon: 'assets/img/selfLearn/menu-learn.svg',
    routeUrl: 'selfLearn-V2',
    menuName: 'Learn',
    class: 'bookmark-size',
    allowedUrls: ['selfLearn-V2'],
  },
  // {
  //   active: true,
  //   module: 'CYOP',
  //   activeIcon: 'assets/img/selfLearn/menu-learn-selected.svg',
  //   nonactiveIcon: 'assets/img/selfLearn/menu-learn.svg',
  //   routeUrl: 'selfLearn-V2/cyop',
  //   menuName: 'CYOP',
  //   class: 'bookmark-size',
  //   allowedUrls: ['selfLearn-V2','cyop'],
  // },
  {
    active: true,
    module: 'assessment',
    activeIcon: 'assets/img/dashboard/active-menu-icons/test-active-icon.svg',
    nonactiveIcon: 'assets/img/dashboard/menu-icons/tests-icon.svg',
    routeUrl: '/dashboard/assessment',
    menuName: 'Tests',
    class: '',
    allowedUrls: ['assessment', 'testlist'],
  },
  // {
  //   active:environment.displayDoubtsWeb,
  //   module:'doubts',
  //   activeIcon:'assets/img/dashboard/active-menu-icons/doubts-active-icon.svg',
  //   nonactiveIcon:'assets/img/dashboard/menu-icons/doubts-icon.svg',
  //   routeUrl:'/dashboard/doubts',
  //   menuName:'Doubts 24/7',
  //   class:"doubts-icon",
  //   allowedUrls:['doubts']
  // }
];
export const secondNavigationLink: any = [
  {
    active: true,
    module: 'myactivity',
    activeIcon: 'assets/img/activity.svg',
    nonactiveIcon: 'assets/img/activities-icon.svg',
    routeUrl: '/dashboard/myactivity',
    menuName: 'My Activity',
    class: 'doubts-icon',
    allowedUrls: [
      'myactivity',
      'leaderboard',
      'achievements',
      'coins',
      'invite-earn',
    ],
  },
  {
    active: true,
    module: 'mybookmarks',
    activeIcon: 'assets/img/selfLearn/menu-my-bookmarks-selected.svg',
    nonactiveIcon: 'assets/img/selfLearn/menu-my-bookmarks.svg',
    routeUrl: '/dashboard/mybookmarks',
    menuName: 'My Bookmarks',
    class: 'bookmark-size',
    allowedUrls: ['mybookmarks'],
  },
  {
    active: true,
    module: 'subscriptions',
    activeIcon: 'assets/img/dashboard/menu-icons/subscription-active-icon.svg',
    nonactiveIcon: 'assets/img/dashboard/menu-icons/subscription-icon.svg',
    routeUrl: '/dashboard/subscription',
    menuName: 'Subscriptions',
    class: 'doubts-icon',
    allowedUrls: [
      'subscription',
      'subscribedPackages',
      'subscriptionPackages',
      'proceed-to-payment',
      'subscription/mycart',
      'subscription/wishlist',
    ],
  },
];
const one_to_two_grades = {
  APTITUDETEST: menuItem_no_selflearn_bookmark_liveclass,
};
const three_to_grades = { APTITUDETEST: menuItem_no_selflearn_bookmark };

export const allowedMenuItems = {
  '1': one_to_two_grades,
  '2': one_to_two_grades,
  '3': three_to_grades,
  '4': three_to_grades,
  '5': three_to_grades,
  '6': {'CBSE':lefsideMenuItes, 'FOUNDATIONTEST':menuItem_no_selflearn_bookmark },
  '7': {'CBSE':lefsideMenuItes, 'FOUNDATIONTEST':menuItem_no_selflearn_bookmark, 'IJSO': menuItem_no_selflearn_bookmark_doubts},
  '8': {'CBSE':lefsideMenuItes, 'FOUNDATIONTEST':lefsideMenuItes, 'RMO': menuItem_no_selflearn_bookmark_doubts, 'IJSO': menuItem_no_selflearn_bookmark_doubts},
  '9': {'CBSE':lefsideMenuItes, 'NEET':lefsideMenuItes, 'JEEMAIN':lefsideMenuItes, 'RMO': menuItem_no_selflearn_bookmark_doubts, 'IJSO': menuItem_no_selflearn_bookmark_doubts},
  '10': {'CBSE':lefsideMenuItes, 'NEET':lefsideMenuItes, 'JEEMAIN':lefsideMenuItes, 'RMO': menuItem_no_selflearn_bookmark_doubts},
  '11': {'CBSE':lefsideMenuItes,  ...commonExamTypeMenuitems},
  '12': {'CBSE':lefsideMenuItes, ...commonExamTypeMenuitems, 'CUET': menuItem_no_selflearn_bookmark },
  '13': { ...commonExamTypeMenuitems },
};
export const notAllowedMenuItems = {
  '1': { APTITUDETEST: ['selfLearn', 'mybookmarks', 'myactivity'] },
  '2': { APTITUDETEST: ['selfLearn', 'mybookmarks', 'myactivity'] },
  '3': { APTITUDETEST: ['selfLearn', 'mybookmarks', 'myactivity'] },
  '4': { APTITUDETEST: ['selfLearn', 'mybookmarks', 'myactivity'] },
  '5': { APTITUDETEST: ['selfLearn', 'mybookmarks', 'myactivity'] },
  '6': { CBSE: [], FOUNDATIONTEST: ['selfLearn', 'mybookmarks', 'myactivity'] },
  '7': { CBSE: [], FOUNDATIONTEST: ['selfLearn', 'mybookmarks', 'myactivity'], 'IJSO': ['selfLearn', 'mybookmarks'] },
  '8': { CBSE: [], FOUNDATIONTEST: ['selfLearn', 'mybookmarks'], 'RMO': ['selfLearn', 'mybookmarks'], 'IJSO': ['selfLearn', 'mybookmarks'] },
  '9': { CBSE: [], NEET: [], JEEMAIN: [], 'RMO': ['selfLearn', 'mybookmarks'], 'IJSO': ['selfLearn', 'mybookmarks'] },
  '10': { CBSE: [], NEET: [], JEEMAIN: [], 'RMO': ['selfLearn', 'mybookmarks'] },
  '11': { CBSE: [], NEET: [], JEEMAIN: [], JEEADVANCED: [] },
  '12': { CBSE: [], NEET: [], JEEMAIN: [], JEEADVANCED: [] },
  '13': { NEET: [], JEEMAIN: [], JEEADVANCED: [] },
};
export const allSubjectsInOrder = [
  'MAT',
  'PHYSICS',
  'CHEMISTRY',
  'BIOLOGY',
  'BOTANY',
  'MATHEMATICS',
  'ZOOLOGY',
  'BRAINTEASERS',
  'SCIENCE',
  'QUANTITATIVEREASONING',
  'SPATIALREASONING',
  'VERBALREASONING',
  'ENGLISH',
  'SOCIALSTUDIES',
  'CRITICALTHINKING',
  'LOGICALREASONING',
  'PROBLEMSOLVING',
  'GENERALTEST',
  'ENGLISHV1',
  'GENERALSCIENCE',
  'MENTALABILITY'
];
export const subjectsPascalCase = {
  PHYSICS: 'Physics',
  CHEMISTRY: 'Chemistry',
  BIOLOGY: 'Biology',
  BOTANY: 'Botany',
  MATHEMATICS: 'Mathematics',
  ZOOLOGY: 'Zoology',
};

export const subjectLogos: any = {
  BOTANY: 'assets/img/subject-icons/botany-icon.svg',
  BIOLOGY: 'assets/img/subject-icons/biology-icon.svg',
  CHEMISTRY: 'assets/img/subject-icons/chemistry-icon.svg',
  PHYSICS: 'assets/img/subject-icons/physics-icon.svg',
  MATHEMATICS: 'assets/img/subject-icons/maths-icon.svg',
  MAT: 'assets/img/subject-icons/maths-icon.svg',
  ZOOLOGY: 'assets/img/subject-icons/biology-icon.svg',
  BRAINTEASERS: 'assets/img/subject-icons/maths-icon.svg',
  SCIENCE: 'assets/img/subject-icons/physics-icon.svg',
  QUANTITATIVEREASONING: 'assets/img/subject-icons/maths-icon.svg',
  SPATIALREASONING: 'assets/img/subject-icons/maths-icon.svg',
  VERBALREASONING: 'assets/img/subject-icons/maths-icon.svg',
  ENGLISH: 'assets/img/subject-icons/english-icon.svg',
  SOCIALSTUDIES: 'assets/img/subject-icons/maths-icon.svg',
  CRITICALTHINKING: 'assets/img/subject-icons/critical-thinking.svg',
  LOGICALREASONING: 'assets/img/subject-icons/logical-reasoning.svg',
  PROBLEMSOLVING: 'assets/img/subject-icons/problem-solving.svg',
  GENERALTEST: 'assets/img/subject-icons/generaltest-icon.svg',
  GENERALSCIENCE: 'assets/img/subject-icons/generaltest-icon.svg',
  ENGLISHV1: 'assets/img/subject-icons/english-icon.svg',
  MENTALABILITY: 'assets/img/subject-icons/mentalability-icon.svg',
};
export const subjectroundLogos: any = {
  BOTANY: 'assets/img/subject-icons/botany-rounded-icon.svg',
  BIOLOGY: 'assets/img/subject-icons/bio-roundedicon.svg',
  CHEMISTRY: 'assets/img/subject-icons/chemistry-roundedicon.svg',
  PHYSICS: 'assets/img/subject-icons/physics-roundedicon.svg',
  MATHEMATICS: 'assets/img/subject-icons/maths-roundedicon.svg',
  MAT: 'assets/img/subject-icons/maths-roundedicon.svg',
  MATHS: 'assets/img/subject-icons/maths-roundedicon.svg',
  ZOOLOGY: 'assets/img/subject-icons/zoology-roundedicon.svg',
  BRAINTEASERS: 'assets/img/subject-icons/maths-roundedicon.svg',
  SCIENCE: 'assets/img/subject-icons/physics-roundedicon.svg',
  QUANTITATIVEREASONING: 'assets/img/subject-icons/maths-roundedicon.svg',
  SPATIALREASONING: 'assets/img/subject-icons/maths-roundedicon.svg',
  VERBALREASONING: 'assets/img/subject-icons/maths-roundedicon.svg',
  ENGLISH: 'assets/img/subject-icons/english-roundedicon.svg',
  SOCIALSTUDIES: 'assets/img/subject-icons/maths-roundedicon.svg',
  CRITICALTHINKING: 'assets/img/subject-icons/critical-thinking.svg',
  LOGICALREASONING: 'assets/img/subject-icons/logical-reasoning.svg',
  PROBLEMSOLVING: 'assets/img/subject-icons/problem-solving.svg',
  GENERALTEST: 'assets/img/subject-icons/G.k-roundedicon.svg',
  GENERALSCIENCE: 'assets/img/subject-icons/G.k-roundedicon.svg',
  ENGLISHV1: 'assets/img/subject-icons/english-roundedicon.svg',
  MENTALABILITY: 'assets/img/subject-icons/mentalability-roundedicon.svg',
};
export const subjectDisplayNames: any = {
  BOTANY: 'BOTANY',
  BIOLOGY: 'BIOLOGY',
  CHEMISTRY: 'CHEMISTRY',
  PHYSICS: 'PHYSICS',
  MATHEMATICS: 'MATHEMATICS',
  MAT: 'MAT',
  ZOOLOGY: 'ZOOLOGY',
  BRAINTEASERS: 'Brain Teasers',
  SCIENCE: 'SCIENCE',
  QUANTITATIVEREASONING: 'Quant. Reasoning',
  SPATIALREASONING: 'Spatial Reasoning',
  VERBALREASONING: 'Verbal Reasoning',
  CRITICALTHINKING: 'Critical Thinking',
  LOGICALREASONING: 'Logical Reasoning',
  PROBLEMSOLVING: 'Problem Solving',
  ENGLISH: 'English',
  SOCIALSTUDIES: 'Social Studies',
  GENERALTEST: 'General Test',
  GENERALSCIENCE:  'General SCIENCE',
  ENGLISHV1:'English V1',
  MENTALABILITY:'MENTAL ABILITY'
};

export const courseTypes = {
  status: true,
  message: 'Success',
  exams: [
    {
      examId: 1,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 3,
      examStreamName: 'PCB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'NEET',
      name: 'NEET',
      description: null,
      orderId: 1,
      icon: '',
      createdOn: '2021-11-19T13:40:39.157+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [11, 12, 9, 10, 13],
      subject_Ids: [1, 2, 4, 5],
    },
    {
      examId: 12,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CBSE Grade 12',
      name: 'CBSE Grade 12',
      description: 'CBSE Grade 12',
      orderId: 1,
      icon: '',
      createdOn: '2022-02-24T11:35:50.104+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [12],
      subject_Ids: [1, 2, 3, 6336],
    },
    {
      examId: 11,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CBSE Grade 11',
      name: 'CBSE Grade 11',
      description: 'CBSE Grade 11',
      orderId: 1,
      icon: '',
      createdOn: '2022-02-24T11:35:14.429+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [11],
      subject_Ids: [1, 2, 3, 6336],
    },
    {
      examId: 19,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 3,
      examStreamName: 'PCB',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Andhra Pradesh Board of Education',
      boardId: 5,
      displayName: 'Sr Elite',
      name: 'Sr Elite',
      description: null,
      orderId: 1,
      icon: '',
      createdOn: '2022-06-06T07:33:06.153+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
        {
          tenantId: 2,
          tenantName: 'srichaitanya',
          tenantCode: 'srichaitanya',
        },
      ],
      grade_Ids: [12],
      subject_Ids: [1, 2, 4, 5],
    },
    {
      examId: 20,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 2,
      examStreamName: 'PCM',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Telangana State Board of Intermediate Education',
      boardId: 22,
      displayName: 'Senior C IPL',
      name: 'Sr Icon C IPL',
      description: null,
      orderId: 1,
      icon: '',
      createdOn: '2022-06-06T07:55:07.580+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
        {
          tenantId: 2,
          tenantName: 'srichaitanya',
          tenantCode: 'srichaitanya',
        },
      ],
      grade_Ids: [12],
      subject_Ids: [1, 2, 3],
    },
    {
      examId: 14,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 2,
      examStreamName: 'PCM',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'JEE Foundation Grade 10',
      name: 'JEE Foundation Grade 10',
      description: null,
      orderId: 2,
      icon: '',
      createdOn: '2022-03-25T12:26:47.368+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [10],
      subject_Ids: [1, 2, 3],
    },
    {
      examId: 13,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 2,
      examStreamName: 'PCM',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'JEE Foundation Grade 9',
      name: 'JEE Foundation Grade 9 ',
      description: null,
      orderId: 2,
      icon: '',
      createdOn: '2022-03-25T12:24:43.963+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [9],
      subject_Ids: [1, 2, 3],
    },
    {
      examId: 2,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 2,
      examStreamName: 'PCM',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'JEE Main',
      name: 'JEE Main',
      description: 'Joint Entrance Examination - Main',
      orderId: 2,
      icon: '',
      createdOn: '2021-12-06T05:24:07.610+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [11, 12, 9, 10, 13],
      subject_Ids: [1, 2, 3],
    },
    {
      examId: 16,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 3,
      examStreamName: 'PCB',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'NEET Foundation Grade 10',
      name: 'NEET Foundation Grade 10',
      description: null,
      orderId: 2,
      icon: '',
      createdOn: '2022-03-25T12:34:36.941+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [10],
      subject_Ids: [1, 2, 4, 5],
    },
    {
      examId: 21,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 1,
      examStreamName: 'Not Applicable',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Andhra Pradesh Board of Education',
      boardId: 5,
      displayName: 'Dummy ETOC',
      name: 'Dummy ETOC',
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
      orderId: 2,
      icon: 'https://il-cms-assets.s3.ap-south-1.amazonaws.com/media/1655115194658.png?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEArI1vPDZW33ulriKVaBruJrM%2F5Dko1jtOeqz%2BW4NrQDwCIEw%2F%2F0M352LBZP9X3to%2FjY3XXhhOedj6VXyuolFyXEahKtYECBYQABoMNzI1NDU2NzgwMjc0Igx1Z3Jl5xSs7OQ%2BXcUqswRK8OPqo8IglfjZjyKQHtM0%2FWmTMpXNwiDVABLauIKBZel9dJ3kZGYGBjM1uTzdBJ0oGbYRQZgqHXyJOCDdCYXbEjl9T88ZkQJ%2Ftah4HOQ4WnF2RdAhd1KaU8ZGvTzfOzMX%2BVyAgIoz52MDIVhqQRzH2%2Bfl0iQp6Ph5tROjXjVObngQFiRFjsJGLuDngnBlJQQC4edu091grrSztNG79dC0rjt368uXzof%2BDN1YXXhn0P7VuQNE8zIREgx1t3J%2BVA03OZVPhXIr2LN%2F8%2FCg04jG2PDtHT8CPS%2BMe5rR1FPy4Ch8RMwcXKP9BxQDoHb71e2dLIXad%2FwSPgmqFhupytzccdIowO%2B8nhhjcVCDgBu03E35vFjl20idlXTNkzullgvAdPqRSDEP%2Bz7M5Pn3yHxsI2rh2wsH9ftkAjehf8eaS60ZqdZrR%2FiLsTMHkVV6b8uGFy9ei%2FWs1d2izR%2FkfT2JJVztHPmhNL3hTivi8GNi1zrEQtnW5EE%2BSnaFaBHHElV0vX9nW6HAI3k00YcFkBGjGNxSWHWtLXvQv7hxdNcosxpDOY6F%2FZZkbhSfkmTzbl2r2%2Br82R1IL%2B6RviJ4NFYIwFZB4D5B%2BJG74tGfahOwHV4O88AZKvktVpi%2B%2FeQr1w4g1n5Yz4skQZbVmOma1yw4DQdQlMikJPyWWdsuGSDENHxFVa6N8YutI1FeLEck3ly4ceYJ5Sy65o9TXDTgF%2BnWdiYbiNa%2F3EWb0mm1efq%2Bf14WizDPp4%2BXBjqpAbhotRJwpOxCtvOP89TisbGo8%2BLTsyzFYA8dDQIDQLCj0zGT5z%2BrLE2Ru8%2Bu%2BtQJJ05Q1Wm9V10Px13MmmGfVXT5SoUjYl2FA44lNAXYCcrt9uFxEkIlE%2F9S64hLGziViXUkDEP6LfUAwLz9yNITjxvzyMvgFvNbUJYkCgyhtY44%2FqY61Jxy8aBaolM1z5VepEoLriEhQpZGmivK7w1DCDl0zu6HFhbAHKw%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20220729T131713Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3600&X-Amz-Credential=ASIA2R2EX7PZNGYKDONY%2F20220729%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=be646429c551078096806333612c3510298107962ed4eb6bb2f8ca6b72a411fa',
      createdOn: '2022-06-13T10:13:14.788+00:00',
      tenants: [
        {
          tenantId: 2,
          tenantName: 'srichaitanya',
          tenantCode: 'srichaitanya',
        },
      ],
      grade_Ids: [7],
      subject_Ids: [1, 2, 3],
    },
    {
      examId: 15,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 3,
      examStreamName: 'PCB',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'NEET Foundation Grade 9',
      name: 'NEET Foundation Grade 9',
      description: null,
      orderId: 2,
      icon: '',
      createdOn: '2022-03-25T12:33:41.702+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [9],
      subject_Ids: [1, 2, 4, 5],
    },
    {
      examId: 3,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 2,
      examStreamName: 'PCM',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'JEE Advanced',
      name: 'JEE Advanced',
      description: 'Joint Entrance Examination - Advanced',
      orderId: 3,
      icon: '',
      createdOn: '2021-12-06T05:24:48.517+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [11, 12, 9, 10, 13],
      subject_Ids: [1, 2, 3],
    },
    {
      examId: 6,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CBSE Grade 6',
      name: 'CBSE Grade 6',
      description: null,
      orderId: 6,
      icon: '',
      createdOn: '2022-02-23T16:17:53.042+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [6],
      subject_Ids: [1, 2, 3, 6336, 7509, 7511, 7512, 7513, 10279],
    },
    {
      examId: 7,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CBSE Grade 7',
      name: 'CBSE Grade 7',
      description: null,
      orderId: 7,
      icon: '',
      createdOn: '2022-02-23T16:20:13.346+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [7],
      subject_Ids: [1, 2, 3, 6336, 7509, 7511, 7512, 7513, 10279],
    },
    {
      examId: 8,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CBSE Grade 8',
      name: 'CBSE Grade 8',
      description: null,
      orderId: 8,
      icon: '',
      createdOn: '2022-02-23T16:20:46.665+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [8],
      subject_Ids: [1, 2, 3, 6336, 7509, 7511, 7512, 7513, 10279],
    },
    {
      examId: 9,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CBSE Grade 9',
      name: 'CBSE Grade 9',
      description: null,
      orderId: 9,
      icon: '',
      createdOn: '2022-02-23T16:21:30.300+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [9],
      subject_Ids: [1, 2, 3, 6336, 7509, 7510, 7511, 7512, 7513, 10279],
    },
    {
      examId: 10,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CBSE Grade 10',
      name: 'CBSE Grade 10',
      description: null,
      orderId: 10,
      icon: '',
      createdOn: '2022-02-23T16:22:06.264+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [10],
      subject_Ids: [1, 2, 3, 6336, 7509, 7510, 7511, 7512, 7513, 10279],
    },
    {
      examId: 18,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Telangana State Board of Intermediate Education',
      boardId: 22,
      displayName: 'TS Intermediate Second Year',
      name: 'TS Intermediate Second Year',
      description: null,
      orderId: 18,
      icon: '',
      createdOn: '2022-04-18T11:10:33.989+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [12],
      subject_Ids: [1, 2, 3, 4, 5],
    },
    {
      examId: 17,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Telangana State Board of Intermediate Education',
      boardId: 22,
      displayName: 'TS Intermediate first year',
      name: 'TS Intermediate First Year',
      description: null,
      orderId: 18,
      icon: '',
      createdOn: '2022-04-18T09:27:31.776+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [11],
      subject_Ids: [1, 2, 3, 4, 5],
    },
    {
      examId: 4,
      examTypeId: 2,
      examTypeName: 'Competitive exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 1,
      examStatusName: 'Draft',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'Foundation Test',
      name: 'Foundation Test',
      description: 'Foundation Test ',
      orderId: 100,
      icon: '',
      createdOn: '2021-12-07T08:28:30.414+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [6, 7, 8],
      subject_Ids: [3, 5348, 5349],
    },
    {
      examId: 5,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Not Applicable',
      boardId: 1,
      displayName: 'Aptitude Test',
      name: 'Aptitude Test',
      description: 'Aptitude Test',
      orderId: 100,
      icon: '',
      createdOn: '2021-12-07T08:37:03.295+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
        },
      ],
      grade_Ids: [3, 4, 5],
      subject_Ids: [3, 6420, 6421, 6422],
    },
    {
      examId: environment.branch == 'staging' ? 28 : 40,
      examTypeId: 1,
      examTypeName: 'Board exam',
      examStreamId: 4,
      examStreamName: 'PCMB',
      examStatusId: 2,
      examStatusName: 'Active',
      boardName: 'Central Board of Secondary Education',
      boardId: 2,
      displayName: 'CUET',
      name: 'CUET',
      description: null,
      orderId: 40,
      icon: '',
      createdOn: '2022-11-17T06:39:46.856+00:00',
      tenants: [
        {
          tenantId: 1,
          tenantName: 'infinitylearn',
          tenantCode: 'infinitylearn',
          createdOn: null,
          modifiedOn: null,
          status: null,
        },
      ],
      grade_Ids: [12],
      subject_Ids: [1, 2, 3, 6050, 6336, 7511],
    },
  ],
};

export const timeBoundTypes = [
  'New NEET Timebound',
  'TIMEBOUND',
  'GRANDTEST',
  'SCHOLARSHIPTEST',
  'RAPTimeBound',
  'b9f32e18-34e8-11ed-a261-0242ac120002',//RRRTS JEE MAIN
  'SCOREAWAT',
  '1eda50ee-65be-11ed-9022-0242ac120002',
  'a851d6b8-65bd-11ed-9022-0242ac120002',
  'd0e5c8fa-65bd-11ed-9022-0242ac120002',
];
export const nonTimeBoundTypes = [
  'New NEET Mock Test',
  'MOCKTEST',
  'PREVIOUSYEAR',
  'SCOREMOCKTEST',
  'RAPDailyTest',
  'cf03ca38-34e8-11ed-a261-0242ac120002',///RRDT JEE MAIN
  '67521',
  '337edf2e-65be-11ed-9022-0242ac120002',
  '41d60246-65be-11ed-9022-0242ac120002',
  '6649791e-65be-11ed-9022-0242ac120002',
  '71dd90e4-65be-11ed-9022-0242ac120002',
  '7dfddc62-65be-11ed-9022-0242ac120002',
  'a132a744-65be-11ed-9022-0242ac120002',
  'afa94d8c-65be-11ed-9022-0242ac120002',
  'SUBJECTIVEMOCKTEST'
];
export const neetNewVerTypes = [
  'New NEET Timebound',
  'New NEET Mock Test',
  'GRANDTEST',
];
export const irregularExamtypes = [
  'ASSIGNMENTS',
  'CHAPTERTESTS',
  'SCHOLARSHIPTEST',
  'ASSIGNMENT',
  'RAPTimeBound',
  'b9f32e18-34e8-11ed-a261-0242ac120002',//RRRTS JEE MAIN
];

export const scorePerQuestion: any = 4;
export const negativeScorePerQuestion: any = 1;
export const ILDomains: any = {
  development: 'https://staging.devinfinitylearn.in',
  staging: 'https://staging.devinfinitylearn.in',
  preprod: 'https://devinfinitylearn.in',
  production: 'https://infinitylearn.com',
};

export const SCDomains: any = {
  development: 'https://scstaging.devinfinitylearn.in',
  staging: 'https://scstaging.devinfinitylearn.in',
  preprod: 'https://srichaitanya.devinfinitylearn.in',
  production: 'https://srichaitanya.infinitylearn.com',
};

export const neetPackages: any[] = [
  {
    name: 'TARGET NEET 2022',
    displayName: 'NEET 2022',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '13th',
    subjects: ['Physics', 'Chemistry', 'Botany', 'Zoology'],
    subjectsDisplayName: 'Physics, Chemistry, Botany and Zoology',
    examName: 'NEET',
    year: '2022',
    syllabus: 'Full Syllabus of Grade 11 & 12',
    header: 'neetheader',
  },
  {
    name: 'TARGET NEET 2022',
    displayName: 'NEET 2022',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '12th',
    subjects: ['Physics', 'Chemistry', 'Botany', 'Zoology'],
    subjectsDisplayName: 'Physics, Chemistry, Botany and Zoology',
    examName: 'NEET',
    year: '2022',
    syllabus: 'Full Syllabus of Grade 11',
    header: 'neetheader',
  },
  {
    name: 'TARGET NEET 2023',
    displayName: 'NEET 2023',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '11th',
    subjects: ['Science', 'Mathematics'],
    subjectsDisplayName: 'Science and Mathematics',
    examName: 'NEET',
    year: '2023',
    syllabus: 'Full Syllabus of Grade 10',
    header: 'neetheader',
  },
  {
    name: 'TARGET 10th foundation',
    displayName: 'NEET 2024',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '10th',
    subjects: ['Science', 'Mathematics'],
    subjectsDisplayName: 'Science and Mathematics',
    examName: 'NEET',
    year: '2024',
    syllabus: 'Full Syllabus of Grade 9',
    header: 'neetheader',
  },
  {
    name: 'TARGET 9th foundation',
    displayName: 'NEET 2025',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '9th',
    subjects: ['Science', 'Mathematics'],
    subjectsDisplayName: 'Science and Mathematics',
    examName: 'NEET',
    year: '2025',
    syllabus: 'Full Syllabus of Grade 8',
    header: 'neetheader',
  },
];
export const jeePackages: any[] = [
  {
    name: 'TARGET JEE Main 2022',
    displayName: 'JEE Main 2022',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '13th',
    subjects: ['Physics', 'Chemistry', 'Mathematics'],
    subjectsDisplayName: 'Physics, Chemistry and  Mathematics',
    examName: 'JEEMAIN',
    year: '2022',
    syllabus: 'Full Syllabus of Grade 11 & 12',
    header: 'jeeheader',
  },
  {
    name: 'TARGET JEE Main 2022',
    displayName: 'JEE Main 2022',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '12th',
    subjects: ['Physics', 'Chemistry', 'Mathematics'],
    subjectsDisplayName: 'Physics, Chemistry and  Mathematics',
    examName: 'JEEMAIN',
    year: '2022',
    syllabus: 'Full Syllabus of Grade 11',
    header: 'jeeheader',
  },
  {
    name: 'TARGET JEE Main 2023',
    displayName: 'JEE Main 2023',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '11th',
    subjects: ['Science', 'Mathematics'],
    subjectsDisplayName: 'Science and Mathematics',
    examName: 'JEEMAIN',
    year: '2023',
    syllabus: 'Full Syllabus of Grade 10',
    header: 'jeeheader',
  },
  {
    name: 'TARGET 10th foundation',
    displayName: 'JEE Main 2024',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '10th',
    subjects: ['Science', 'Mathematics'],
    subjectsDisplayName: 'Science and Mathematics',
    examName: 'JEEMAIN',
    year: '2024',
    syllabus: 'Full Syllabus of Grade 9',
    header: 'jeeheader',
  },
  {
    name: 'TARGET 9th foundation',
    displayName: 'JEE Main 2025',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '9th',
    subjects: ['Science', 'Mathematics'],
    subjectsDisplayName: 'Science and Mathematics',
    examName: 'JEEMAIN',
    year: '2025',
    syllabus: 'Full Syllabus of Grade 8',
    header: 'jeeheader',
  },
];
export const jeeAdvancedPackages: any[] = [
  {
    name: 'TARGET JEE Advanced 2022',
    displayName: 'JEE Advanced 2022',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '13th',
    subjects: ['Physics', 'Chemistry', 'Mathematics'],
    subjectsDisplayName: 'Physics, Chemistry and  Mathematics',
    examName: 'JEEADVANCED',
    year: '2022',
    syllabus: 'Full Syllabus of Grade 11 & 12',
    header: 'jeemainheader',
  },
  {
    name: 'TARGET JEE Advanced 2022',
    displayName: 'JEE Advanced 2022',
    date: '10th Oct, 2 PM to 3:30 PM',
    grade: '12th',
    subjects: ['Physics', 'Chemistry', 'Mathematics'],
    subjectsDisplayName: 'Physics, Chemistry and  Mathematics',
    examName: 'JEEADVANCED',
    year: '2022',
    syllabus: 'Full Syllabus of Grade 11',
    header: 'jeemainheader',
  },
  // {
  //   name:'TARGET JEE Advanced 2023',
  //   displayName:'JEE Advanced 2023',
  //   date:'10th Oct, 2 PM to 3:30 PM',
  //   grade:'11th',
  //   subjects:['Science', 'Mathematics'],
  //   subjectsDisplayName:'Science and Mathematics',
  //   examName:'JEEADVANCED',
  //   year:'2023',
  //   syllabus: 'Full Syllabus of Grade 10',
  //   header: 'jeemainheader'
  // },
  // {
  //   name:'TARGET JEE Advanced 2024',
  //   displayName:'JEE Advanced 2024',
  //   date:'10th Oct, 2 PM to 3:30 PM',
  //   grade:'10th',
  //   subjects:['Science', 'Mathematics'],
  //   subjectsDisplayName:'Science and Mathematics',
  //   examName:'JEEADVANCED',
  //   year:'2024',
  //   syllabus: 'Full Syllabus of Grade 9',
  //   header: 'jeemainheader'
  // }
];

export const allowedGrades = {
  infinitylearn: {
    default: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
    ],
  },
  ILTSC: {
    default: ['8', '9', '10', '11', '12', '13'],
  },
  imami: {
    default: ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
  },
  srichaitanya: {
    default: ['9', '10', '11', '12', '13'],
    SCORE: ['6', '7', '8', '9', '10', '11', '12', '13'],
  },
};
export const examDisplayNames: any = {
  JEEMAIN: 'JEE Main',
 'JEE Main': 'JEE Main',
  JEEADVANCED: 'JEE Advanced',
  NEET: 'NEET',
  CBSE: 'CBSE',
  FOUNDATIONTEST: 'Foundation Test',
  APTITUDETEST: 'Aptitude Test',
  CUET: 'CUET',
  RMO: 'RMO',
  IJSO: 'IJSO',
};

export const examDisplayMyActivity: any = {
  FOUNDATIONTEST: 'FOUNDATIONTEST',
  APTITUDETEST: 'APTITUDETEST',
};

export const badgesDetailsConstants: any = {
  GettingStarted: {
    name: 'Getting started',
    badgeId: 1,
    globalBadges: true,
    rewardDescription:'You have completed your profile'
  },
  GoalSetter: {
    name: 'Goal Setter',
    badgeId: 2,
    globalBadges: false,
    gifImages: "'assets/images/goal getter1.gif'",
    rewardDescription:'You have finished under 100 in the weekly leaderboard'
  },
  'Weekend Warrior': {
    name: 'Weekend Warrior',
    badgeId: 3,
    globalBadges: false,
    rewardDescription:'You have finished a topic from self-learn on a weekend'
  },
  Incquisitive: {
    name: 'Incquisitive',
    badgeId: 4,
    globalBadges: false,
    rewardDescription:'You have connected with a tutor by posting 1 doubt'
  },
  Listener: {
    name: 'Listener',
    badgeId: 5,
    globalBadges: false,
    rewardDescription:'You have attended 10 hours of live classes'
  },
  '7dayStreak': {
    name: '7-day Streak',
    badgeId: 6,
    globalBadges: true,
    rewardDescription:'You have reached 7-days streak'
  },

  Scholar: {
    name: 'Scholar',
    badgeId: 7,
    globalBadges: false,
    rewardDescription:'You have completed 2 chapters from Self-learn'
  },
  Challenger: {
    name: 'Challenger',
    badgeId: 8,
    globalBadges: false,
    rewardDescription:'You have finished under 100 in the weekly leaderboard '
  },
  'Bulls eye': {
    name: 'Bulls eye',
    badgeId: 9,
    globalBadges: false,
    rewardDescription:'You have got more than 90% in ILTS'
  },
  Sharpshooter: {
    name: 'Sharpshooter',
    badgeId: 10,
    globalBadges: false,
    rewardDescription:'You have got more than 90% in mock test'
  },
  Champion: {
    name: 'Champion',
    badgeId: 11,
    globalBadges: false,
    rewardDescription:'You have finished under 10 in the monthly leaderboard'
  },
  Strategist: {
    name: 'Strategist',
    badgeId: 12,
    globalBadges: false,
    rewardDescription:'You have completed 20 flash cards'
  },
  '30dayStreak': {
    name: '30-day Streak',
    badgeId: 13,
    globalBadges: true,
    rewardDescription:'You have reached 30-days streak'
  },
  Banker: {
    name: 'Banker',
    badgeId: 14,
    globalBadges: true,
    rewardDescription:'You have earned a total of 20,000 coins'
  },
  Messenger: {
    name: 'Messenger',
    badgeId: 15,
    globalBadges: true,
    rewardDescription:'You have invited 10 friends'
  },
};

export const apisDataCacheKeys: any = {
  allTests: 'all_exams_details_from_server',
  atemptedTests: 'attempted_exams_details_from_server',
  atemptedTestRecord: 'attempted_exam_details_from_server',
  allChapters: 'chapters_details_from_server',
  userDetails: 'user_details_from_server',
  payments: 'subscription_payments',
  selectedExam:'selectedExam'
};

export const testActionsTexts = {
  attempt_now: 'ATTEMPT NOW',
  resume_now: 'RESUME NOW',
  view_report: 'VIEW ASSIGNMENT REPORT',
};

export const gradeField = {
  user: 'grade',
  [apisDataCacheKeys.allTests]: 'className',
  [apisDataCacheKeys.atemptedTests]: 'studentClass',
};
export const subscription_999_ids: any = {
  staging: {
    NEET: {
      expected_packageId: 71,
      replace_packageId: 29,
    },
    JEEMAIN: {
      expected_packageId: 72,
      replace_packageId: 30,
    },
  },
  production: {
    NEET: {
      expected_packageId: 75,
      replace_packageId: 70,
    },
    JEEMAIN: {
      expected_packageId: 76,
      replace_packageId: 67,
    },
  },
};
subscription_999_ids.preprod = subscription_999_ids.staging;
export const homeRoute =
  environment.tenant == 'infinitylearn' ? environment.homeRoute : '/';
export const studentDashboard =
  environment.tenant == 'infinitylearn' ? environment.studentDashboard : '/';
export const dashboardRoute = '/dashboard';
export const commonWebsite = true;

export const avatarImagesPath =
  'https://il-uiassets.s3.ap-south-1.amazonaws.com/userdatauploads/infinitylearn/avatars/';
export const avatarImages = [
  'male.svg',
  'male-1.svg',
  'male-2.svg',
  'male-3.svg',
  'female.svg',
  'female-1.svg',
  'female-2.svg',
  'female-3.svg',
];

export const profileSuccess = {
  personalDetails: {
    message1: `Personal Details updated`,
    message2: `Your Personal Details has been successfully updated`,
  },
  targetExam: {
    message1: `Target Exams updated`,
    message2: `Your Target Exams has been successfully updated`,
  },
  academicDetails: {
    message1: `Academic Details updated`,
    message2: `Your Academic Details has been successfully updated`,
  },
  gradeExamEdit: {
    message1: `Academic Details And Target Exams updated`,
    message2: `Your Academic Details And Target Exams has been successfully updated`,
  },
};

export const cartActionMsg = {
  additem: {
    message1: `Subscription moved to wishlist`,
    message2: `If you wish to remove Subscription, click delete`,
  },
  deleteitem: {
    message1: `Subscription removed from cart`,
    message2: `Wish to add it back to cart? `,
  },
  deleteWishItem: {
    message1: `Subscription removed from Wishlist`,
    message2: `Wish to add it back to wishlist? `,
  },
  addtocart: { message1: `Subscription added to cart`, message2: `` },
};
const tenantDetails = Object.freeze({
  //maintain alphabetical order
  infinitylearn: {
    allowedExamTypesCT: {
      '3': ['SCHOLARSHIPTEST'],
      '4': ['SCHOLARSHIPTEST'],
      '5': ['SCHOLARSHIPTEST'],
      '6': ['SCHOLARSHIPTEST'],
      '7': ['SCHOLARSHIPTEST'],
      '8': ['SCHOLARSHIPTEST'],
      '9': ['SCHOLARSHIPTEST'],
      '10': ['SCHOLARSHIPTEST'],
    },
    //dont allow certain grade students to attempt a particular examtype
    //if a grade is not present in this obj, it means all examtypes are allowed for students of that grade for that tenant
    allowedGrades: ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
    //dont allow certain grade students for a tenant
    allowProfileUpdate: true,
    //to show or hide editProfile button in profile page
    idMaxLength: 10,
    //max length of the input field(for unique ID, i.e. phone, admn. num. etc...) in the signup or sign screen
    liveclasses: true,
    // to enable or not, the live classes experience
    loginPlaceHolder: 'Phone Number',
    //to use in login screen input place holder and other places
    multiDomain: true, //i.e main portal and student portal are different
    //in this case, they use signin.compo.ts
    passwordRegex: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{6,}$/,

    //to use in signup screen validations and other places
    showBanners: true,
    //banners of "attempt PYPs in assessments dashboard" and "register for free live class in live class dashboard"
    showOTPLogin: true,
    subscriptions: true,
    //payments in website
    toRegisterBeforeAttempt: true,
    //should user register before attempting a timebound?
    uniqueIDRegex: /^[26-9][0-9]{9}$/,
    //to use in login screen validations and other places
  },
  srichaitanya: {
    //maintain alphabetical order
    allowedExamTypesCT:
      portal == 'SCORE'
        ? {}
        : {
            // '3': ['SCHOLARSHIPTEST'],
            // '4': ['SCHOLARSHIPTEST'],
            // '5': ['SCHOLARSHIPTEST'],
            // '6': ['SCHOLARSHIPTEST'],
            // '7': ['SCHOLARSHIPTEST'],
            // '8': ['SCHOLARSHIPTEST'],
            // '9': ['SCHOLARSHIPTEST'],
            // '10': ['SCHOLARSHIPTEST'],
          },
    allowedGrades:
      portal == 'SCORE'
        ? ['6', '7', '8', '9', '10', '11', '12', '13']
        : ['9', '10', '11', '12', '13'],
    allowProfileUpdate: false,
    heroImage: 'home-hero-bg.png',
    heroImageMob: 'homeimage2.png',
    idMaxLength: portal == 'SCORE' ? 10 : 13,
    liveclasses: true,
    loginPlaceHolder: portal == 'SCORE' ? 'Phone Number' : 'Admission Number',
    multiDomain: false,
    // in this case, we use angular-ui\src\app\modules\shared\components\admission-number-login\admission-number-login.component.ts
    passwordResetPage: 'https://epraghna.com/studentLogin',
    showBanners: false,
    showOTPLogin: false,
    subscriptions: false,
    toRegisterBeforeAttempt: false,
    //should user register before attempting a timebound?
    uniqueIDRegex:
      portal == 'SCORE'
        ? /^[6-9][0-9]{9}$/
        : /^((scs[0-9]{6,9})|(ts[0-9]{6,10})|([0-9]{9}))$/i,
  },
  imamia: {
    //maintain alphabetical order
    allowedExamTypesCT: {
      '3': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '4': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '5': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '6': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '7': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '8': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '9': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '10': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '11': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '12': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
      '13': [
        'TIMEBOUND',
        'New NEET Timebound',
        'MOCKTEST',
        'New NEET Mock Test',
      ],
    },
    allowedGrades: ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
    allowProfileUpdate: false,
    email: 'hyflex@infinitylearn.com',
    heroImage: 'home-hero-bg.png',
    heroImageMob: 'homeimage2.png',
    idMaxLength: 10,
    liveclasses: false,
    loginPlaceHolder: 'Phone Number',
    multiDomain: false,
    // in this case, we use angular-ui\src\app\modules\shared\components\admission-number-login\admission-number-login.component.ts
    showBanners: false,
    showOTPLogin: true,
    subscriptions: false,
    toRegisterBeforeAttempt: false,
    //should user register before attempting a timebound?
    uniqueIDRegex: /^[26-9][0-9]{9}$/,
  },
});
const paidSubscribedTest = [
  'NEW NEET TIMEBOUND',
  'TIMEBOUND',
  'SCHOLARSHIPTEST',
  'NEW NEET MOCK TEST',
  'MOCKTEST',
  'RAPDAILYTEST',
  'CF03CA38-34E8-11ED-A261-0242AC120002',// RRDT JEE MAIN
  'B9F32E18-34E8-11ED-A261-0242AC120002',//RRRTs
  'RAPTIMEBOUND',
  '67521',
  'A851D6B8-65BD-11ED-9022-0242AC120002',
  'D0E5C8FA-65BD-11ED-9022-0242AC120002',
  '337EDF2E-65BE-11ED-9022-0242AC120002',
  '41D60246-65BE-11ED-9022-0242AC120002',
  'SUBJECTIVEMOCKTEST'
];

export const curTenantDetails = tenantDetails[tenant];
export const showBannerGrades = ['11', '12', '13'];
export const PaidSubscribedTest = paidSubscribedTest;
export const Admin = 'Super Admin';
export class ApiUrlConstant {
  static readonly apiUrl = environment.api;
  static readonly examUrl = environment.api1;
  static readonly omsdevapi = environment.omsdevapi;
  static readonly ePragnaUrl = environment.ePragnaUrl;
  static readonly LIVE_CLASS_API = environment.LIVE_CLASS_API;
  static readonly SELF_LEARN_API = environment.SELF_LEARN_API;
  static readonly SELF_LEARN_API_V2 = environment.SELF_LEARN_API_V2;
  static readonly uafapi = environment.uafapi;

  static readonly myActivity = environment.myActivity_url;
  static readonly cmsapi = environment.CMS_API;
  static readonly peakmindenpoint = environment.peakmindenpoint;
}

export const focusExamURL = [
  '/dashboard',
  '/dashboard/liveclass',
  '/dashboard/classes',
  '/dashboard/masterclasses',
  '/dashboard/all-courses',
  '/dashboard/my-courses',
  '/dashboard/assessment',
  '/dashboard/testlist',
  '/dashboard/subscriptionPackages',
  '/subscription/subscriptionPackages',
  '/dashboard/subscribedPackages',
  '/dashboard/subscribedPackages/active',
  '/dashboard/selfLearn',
  '/dashboard/mybookmarks',
];
export const assignmentStatusFilters = [
  { id: null, val: 'All Assignments' },
  { id: 'isTestSubmitted', val: 'Submitted' },
  { id: 'inProgress', val: 'In progress' },
  { id: 'yetToStart', val: 'Yet to start' },
];
export const dateSuffixes = {
  '1': 'st',
  '2': 'nd',
  '3': 'rd',
  '21': 'st',
  '22': 'nd',
  '23': 'rd',
  '31': 'st',
};
export const cbseScienceGrade = ['6', '7', '8', '9', '10'];
export const examgraceTimeConstant = 10; //time is in minutes

export const page_IdFilter = {
  web_il_site: '1',
  signup: '1',
  signin: '1',
  jee: '2',
  neet: '3',
  'cbse/8/full-course': '4',
  'cbse/9/full-course': '5',
  'cbse/10/full-course': '6',
  'cbse/11/full-course': '7',
  'cbse/12/full-course': '8',
  score: '9',
  bhaskar: '10',
  jagran: '11',
  doubts: '12',
  'jee/repeater': '13',
  'neet/repeater': '14',
};

export const CMSTestType = [
  {
    examtype: null,
    name: 'MOCKTEST',
    value: '5f9624f0-098c-41c6-999b-d847c7e4e3a3',
    status: true,
  },
  {
    examtype: null,
    name: 'PREVIOUSYEAR',
    value: '3712e2ca-be34-4b3d-b31c-a645b709348b',
    status: true,
  },
  {
    examtype: null,
    name: 'TIMEBOUND',
    value: '066697cf-709c-4c67-a0bb-e43feb0043d9',
    status: true,
  },
  {
    examtype: null,
    name: 'CHAPTERTESTS',
    value: '1594d5e6-a9bc-4744-bc9d-da20a0ac31be',
    status: true,
  },
  {
    examtype: null,
    name: 'New NEET Mock Test',
    value: '5d6fcff0-1000-45bb-b62a-d3d2b2bd3189',
    status: true,
  },
  {
    examtype: null,
    name: 'New NEET Timebound',
    value: '51592ef8-8334-479f-8a91-7cfe809b7c04',
    status: true,
  },
  {
    examtype: null,
    name: 'GRANDTEST',
    value: 'a47f9f23-6203-4759-8977-cc7542d85b23',
    status: true,
  },
  {
    examtype: null,
    name: 'SCHOLARSHIPTEST',
    value: 'fc180abf-a9cb-4bea-b30e-28d8442ae3b8',
    status: true,
  },
  {
    examtype: null,
    name: 'ASSIGNMENTS',
    value: 'd84ab774-93c5-4869-8c3a-d9d99390b2c0',
    status: 'true',
  },
  {
    examtype: null,
    name: 'SCORE',
    value: 'd2cfdb3b-61b9-4279-ba8e-731c0999de94',
    status: 'true',
  },
  {
    examtype: null,
    name: 'SCOREMOCKTEST',
    value: '6a08ead7-3fe6-45cf-a454-45cb3a4f37d5',
    status: 'true',
  },
  {
    examtype: null,
    name: 'CYOT',
    status: 'true',
    value: '1bd7bef9-83ad-41b1-9d17-89f77559b997',
  },
  {
    examtype: null,
    name: 'QC for Vendor',
    status: 'true',
    value: '888d4e0c-1847-44e3-96a2-b6e1cda4c68d',
  },
  {
    examtype: null,
    name: 'RAPDailyTest',
    status: 'true',
    value: '9edb8ebe-19da-442e-bab6-d03c3de9b1ba',
  },
  {
    examtype: null,
    name: 'RAPTimeBound',
    status: 'true',
    value: '94eb35a0-f8ec-4200-8f0e-78de0ebc37db',
  },
  {
    examtype: null,
    name: 'FREE NEET MOCK TEST',
    status: 'true',
    value: '3d1755e5-6c42-462f-9bc6-626b521b44e1',
  },
  {
    examtype: null,
    name: 'Success Centre Scholarship Test',
    status: 'true',
    value: '42074fa5-6a68-44bd-8eca-459f1e996f85',
  },
  {
    examtype: null,
    name: 'cf03ca38-34e8-11ed-a261-0242ac120002',///RRRDT JEE MAIN
    status: 'true',
    value: 'cf03ca38-34e8-11ed-a261-0242ac120002',
  },
  {
    examtype: null,
    name: 'b9f32e18-34e8-11ed-a261-0242ac120002',//RRRTS JEE MAIN
    status: 'true',
    value: 'b9f32e18-34e8-11ed-a261-0242ac120002',
  },
  {
    examtype: null,
    name: '0ed6411c-65be-11ed-9022-0242ac120002', //CUET Timebound Social
    status: 'true',
    value: '0ed6411c-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: 'subjectivemocktest',
    status: 'true',
    value: '174bbef2-4195-4f51-8468-cb992be74628',
  },
  {
    examtype: null,
    name: '1eda50ee-65be-11ed-9022-0242ac120002', //CUET Timebound Commerce
    status: 'true',
    value: '1eda50ee-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: '337edf2e-65be-11ed-9022-0242ac120002', //CUET Mock Test Science
    status: 'true',
    value: '337edf2e-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: '41d60246-65be-11ed-9022-0242ac120002', //CUET Mock Test GT & English
    status: 'true',
    value: '41d60246-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: '52d43478-65be-11ed-9022-0242ac120002', //CUET Mock Test Social
    status: 'true',
    value: '52d43478-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: '6649791e-65be-11ed-9022-0242ac120002', //"CUET Mock Test Commerce"
    status: 'true',
    value: '6649791e-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: '71dd90e4-65be-11ed-9022-0242ac120002', //CUET PYP Science
    status: 'true',
    value: '71dd90e4-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: '7dfddc62-65be-11ed-9022-0242ac120002', //CUET PYP GT & English
    status: 'true',
    value: '7dfddc62-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: 'a132a744-65be-11ed-9022-0242ac120002', //CUET PYP Social
    status: 'true',
    value: 'a132a744-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: 'a851d6b8-65bd-11ed-9022-0242ac120002', //CUET Timebound Science
    status: 'true',
    value: 'a851d6b8-65bd-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: 'afa94d8c-65be-11ed-9022-0242ac120002', //CUET PYP Commerce
    status: 'true',
    value: 'afa94d8c-65be-11ed-9022-0242ac120002',
  },
  {
    examtype: null,
    name: 'd0e5c8fa-65bd-11ed-9022-0242ac120002', //CUET Timebound GT & English
    status: 'true',
    value: 'd0e5c8fa-65bd-11ed-9022-0242ac120002',
  },
  {
    examtype:null,
    name:'1a3d57d9-f675-4ac6-bcb5-aa4fc4de5d82',
    status:true,
    value:'1a3d57d9-f675-4ac6-bcb5-aa4fc4de5d82'
  },
  {
    examtype:null,
    name:"53355d15-4a4a-4df8-a881-688c43f0c65e",//CQT
    status:true,
    value:"53355d15-4a4a-4df8-a881-688c43f0c65e"
  }
];
export const callUssupportNumber = '18004194247';
export const Oms_package_id: any = Object.freeze({
  score: 7,
  bookspackage: 10,
  ultimate: 3,
  propackage: 1,
  free_pro_package: 1,
});

export const jsonILTS: any = {
  JEE_11th_ILTS: [
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-1',
      Date: '6/5/2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths',
      Chem: 'Some Basic Concepts of Chemistry',
      Maths: 'Fundametals of mathematics',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-1',
      Date: '11-Sep-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths #Physics and measurement #Motion in a straight line',
      Chem: 'Some Basic Concepts of Chemistry  #Structure of Atom',
      Maths: 'Sets and Relations #Quadratic Equations',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-2',
      Date: '12-Jun-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths',
      Chem: 'Some Basic Concepts of Chemistry',
      Maths: 'Sets',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-2',
      Date: '25-Sep-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a plane',
      Chem: 'Some Basic Concepts of Chemistry#Structure of Atom',
      Maths: 'Sequence and series#Trigonometric Ratios',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-3',
      Date: '19-Jun-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths',
      Chem: 'Some Basic Concepts of Chemistry',
      Maths: 'Relations',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-3',
      Date: '9-Oct-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths#Physics and measurement#Motion in a straight line',
      Chem: 'Some Basic Concepts of Chemistry#Structure of Atom',
      Maths: 'Sequence and series#Trigonometric Ratios',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-4',
      Date: '3-Jul-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Units & Measurement',
      Chem: 'Structure of Atom',
      Maths: 'Functions',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-4',
      Date: '23-Oct-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a plane',
      Chem: 'Periodic Classification',
      Maths: 'Sets and Relations # Functions',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-5',
      Date: '17-Jul-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a Straight Line',
      Chem: 'Structure of Atom',
      Maths: 'Trigonometric Functions',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 CT-1',
      Date: '30-Oct-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths #Physics and measurement Motion in a straight line # Motion in a plane',
      Chem: 'Some Basic Concepts of Chemistry # Structure of AtomPeriodic Classification',
      Maths: 'Sets and Relation #Functions',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-5',
      Date: '6-Nov-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion',
      Chem: 'Chemical Bonding',
      Maths:
        'Trigonometric Compound angles#Multiple and Submultiple angles#Trigonometric Transformations',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-6',
      Date: '31-Jul-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a Plane',
      Chem: 'Periodic Classification',
      Maths: 'Quadratic equations',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-6',
      Date: '20-Nov-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Work Power Energy',
      Chem: 'States of Matter',
      Maths: 'Trigonometric equations#Quadratic equations',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-7',
      Date: '14-Aug-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion',
      Chem: 'Chemical bonding',
      Maths: 'Complex numbers',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-7',
      Date: '4-Dec-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of particles and rotational motion',
      Chem: 'Thermo Dynamics',
      Maths: 'Complex numbers # Linear inequalities',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-8',
      Date: '28-Aug-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion',
      Chem: 'Chemical bonding',
      Maths: 'Linear inequalities',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-8',
      Date: '18-Dec-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Gravitation',
      Chem: 'Chemical Equilibrium#Ionic Equilibrium',
      Maths: 'Properties of Triangle ',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-9',
      Date: '11-Sep-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Work, Energy and Power',
      Chem: 'Chemical bonding',
      Maths: 'Trigonometric Functions II',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 CT-2',
      Date: '25-Dec-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion #Work Power Energy # System of particles and rotational motion#Gravitation',
      Chem: 'Chemical Bonding # States of MatterThermo Dynamics #Chemical Equilibrium# Ionic Equilibrium',
      Maths:
        'Trigonometric Compound angles#Multiple and Submultiple angles#Trigonometric Transformations',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-9',
      Date: '1-Jan-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of solids#Mechanical Properties of Fluids',
      Chem: ' Redox Reactions#Hydrogen and its compounds',
      Maths: 'Permutation and Combinations #Binomial Theorem',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-10',
      Date: '25-Sep-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Work, Energy and Power',
      Chem: 'States of matter',
      Maths: 'Permutations and Combinations',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-10',
      Date: '15-Jan-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermal properties of matter',
      Chem: 'Alkali Metals#Alkaline Earth Metals',
      Maths: 'Sequence and Series',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 CT-1',
      Date: '9-Oct-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic MathsUnits & MeasurementMotion in a Straight Line',
      Chem: 'Some Basic Concepts of ChemistryStructure of Atom',
      Maths:
        'Fundametals of mathematicsSetsRelationsFunctionsTrigonometric Functions',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-11',
      Date: '23-Oct-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Work, Energy and Power',
      Chem: 'States of matter',
      Maths: 'Binomial theorem',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-11',
      Date: '29-Jan-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermodynamics#Kinetic theory of gases',
      Chem: '13th Group#14th Group',
      Maths: 'Coordinate Geometry # Straight Lines',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 CT-2',
      Date: '6-Nov-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a PlaneLaws Of Motion ',
      Chem: 'Periodic ClassificationChemical bonding',
      Maths:
        'Principle of Mathematical InductionQuadratic equationsComplex numbersLinear inequalitiesPermutations and Combinations',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-12',
      Date: '20-Nov-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion',
      Chem: 'Thermodynamics',
      Maths: 'Sequences and Series',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-12',
      Date: '12-Feb-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Oscillations',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)',
      Maths: 'Circles#Parabola',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-13',
      Date: '4-Dec-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion',
      Chem: 'EQUILIBRIUM',
      Maths: 'Coordinate geometry (2D)',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 CT-3',
      Date: '19-Feb-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of solids Mechanical Properties of FluidsThermal properties of matterThermodynamicsKinetic theory of gasesOscillations',
      Chem: ' Redox Reactions#Hydrogen and its compoundsAlkali Metals#Alkaline Earth Metals13th Group#14th GroupOrganic Chemistry- Some basic principles and techniques(General Organic)',
      Maths:
        'Permutation and Combinations #Binomial TheoremSequence and SeriesCoordinate Geometry # Straight LinesCircles#Parabola',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-13',
      Date: '26-Feb-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Waves',
      Chem: 'Hydrocarbons#Environmental Chemistry',
      Maths: 'Ellipse # Hyperbola# 3D geometry #Limits # Differentiation',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-14',
      Date: '18-Dec-2022',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Gravitation',
      Chem: 'Redox reaction',
      Maths: 'Coordinate geometry (2D)',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-14',
      Date: '12-Mar-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths Physics and measurement Motion in a straight lineMotion in a planeLaws of MotionWork Power EnergySystem of particles and rotational motion',
      Chem: 'Some Basic Concepts of ChemistryStructure of AtomPeriodic ClassificationChemical BondingStates of MatterThermo Dynamics',
      Maths:
        'Sets and Relations Quadratic EquationsSequence and seriesTrigonometric RatiosSets and RelationsFunctionsTrigonometric Compound anglesMultiple and Submultiple anglesTrigonometric TransformationsTrigonometric equationsComplex numbersLinear inequalities',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-15',
      Date: '1-Jan-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Solids',
      Chem: 'Hydrogen',
      Maths: 'Circles',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-15',
      Date: '26-Mar-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'GravitationMechanical Properties of solidsMechanical Properties of FluidsThermal properties of matterThermodynamics#Kinetic theory of gasesOscillationsWaves',
      Chem: 'Chemical EquilibriumIonic Equilibrium Redox ReactionsHydrogen and its compoundsAlkali MetalsAlkaline Earth Metals13th Group14th GroupOrganic Chemistry- Some basic principles and techniques(General Organic)HydrocarbonsEnvironmental Chemistry',
      Maths:
        'Properties of Triangle Permutation and CombinationsBinomial TheoremSequence and SeriesCoordinate GeometryStraight LinesCirclesParabolaEllipseHyperbola3D geometry LimitsDifferentiation',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 CT-3',
      Date: '8-Jan-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational MotionGravitationMechanical Properties of Solids',
      Chem: 'ThermodynamicsEQUILIBRIUMRedox reactionHydrogen',
      Maths: 'Sequences and SeriesCoordinate geometry (2D)Circles',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-16',
      Date: '15-Jan-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Fluids',
      Chem: 'S-Block',
      Maths: 'Conic Section',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-16',
      Date: '2-Apr-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-17',
      Date: '29-Jan-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermal Properties of Matter',
      Chem: 'P-block',
      Maths: 'Conic Section #Three Dimensional Geometry',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-17',
      Date: '9-Apr-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-18',
      Date: '12-Feb-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Kinetic TheoryThermodynamics',
      Chem: '9-Organic chemistry-some basic principle and techniques',
      Maths: 'Limits #Differentiation',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-18',
      Date: '16-Apr-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-19',
      Date: '26-Feb-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Oscillations#Waves',
      Chem: 'Hydrocarbons#Environmental chemistry',
      Maths: 'Mathematical reasoning #Statistics#Probability',
    },
    {
      test_name: 'JEE Main Grade 11 B-2 ILTS-19',
      Date: '23-Apr-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 CT-4',
      Date: '5-Mar-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of FluidsThermal Properties of MatterKinetic TheoryThermodynamicsOscillationsWaves',
      Chem: 'S-BlockP-block9-Organic chemistry-some basic principle and techniquesHydrocarbonsEnvironmental chemistry',
      Maths:
        'Conic SectionThree Dimensional GeometryLimits #DifferentiationMathematical reasoning StatisticsProbability',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-20',
      Date: '12-Mar-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic MathsUnits & MeasurementMotion in a Straight LineMotion in a PlaneLaws of Motion',
      Chem: 'Some Basic Concepts of ChemistryStructure of AtomPeriodic Classification Chemical bonding',
      Maths:
        'Fundametals of mathematicsSetsRelationsFunctionsTrigonometric FunctionsQuadratic equationsComplex numbersLinear inequalities',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-21',
      Date: '19-Mar-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Work, Energy and PowerSystem of Particles and Rotational MotionGravitationMechanical Properties of SolidsMechanical Properties of FluidsThermal Properties of MatterKinetic TheoryThermodynamicsOscillationsWaves',
      Chem: 'States of matterThermodynamicsEQUILIBRIUMRedox reactionHydrogenS-BlockP-block9-Organic chemistry-some basic principle and techniquesHydrocarbonsEnvironmental chemistry',
      Maths:
        'Trigonometric Functions IIPermutations and CombinationsBinomial theoremSequences and SeriesCoordinate geometry (2D)CirclesConic SectionThree Dimensional GeometryLimits DifferentiationMathematical reasoning StatisticsProbability',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-22',
      Date: '26-Mar-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-23',
      Date: '2-Apr-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-24',
      Date: '9-Apr-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'JEE Main Grade 11 B-1 ILTS-25',
      Date: '16-Apr-2023',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
  ],
  JEE_12th_ILTS:[
    {
      test_name: "JEE Rank Assurance Program ILTS-6",
      Date: "01-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Semiconductor Electronics: Materials, Devices and Simple Circuits, Communication systems",
      Chem:"GeneraI Organic Chemistry",
      Maths: "Mathematical Reasoning, Matrices and Determinants"
    },
    {
      test_name: "JEE Main Grand Test -01 ",
      Date: "03-Jan-23",
      date_time: "(Tues), 4pm to 7pm",
      Phy: "Syllabus of  Grade -XII",
      Chem: "Syllabus of  Grade -XII",
      Maths: "Syllabus of  Grade -XII"
    },
    {
      test_name: "JEE Main Grand Test -02",
      Date: "05-Jan-23",
      date_time: "(Thurs), 4pm to 7pm",
      Phy: "Syllabus of  Grade -XI",
      Chem: "Syllabus of  Grade -XI",
      Maths: "Syllabus of  Grade -XI"
    },
    {
      test_name: "JEE Main Grand Test -03",
      Date: "07-Jan-23",
      date_time: "(Sat), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-7",
      Date: "08-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Ray Optics and Optical Instruments",
      Chem:"GeneraI Organic Chemistry",
      Maths: "Vectors, 3D Geometry,Inverse trogonometric Functions"
    },
    {
      test_name: "JEE Main Grand Test -04",
      Date: "09-Jan-23",
      date_time: "(Mon), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
      
    },
    {
      test_name: "JEE Main Grand Test -05",
      Date: "11-Jan-23",
      date_time: "(Wed), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -06",
      Date: "13-Jan-23",
      date_time: "(Fri), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-8",
      Date: "15-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Wave optics, Dual Nature of Matter and Radiation",
      Chem:"Hydrocarbons",
      Maths: "Trigonometric Equations,Defininite Integration, Areas"
    },
    {
      test_name: "JEE Main Grand Test -07",
      Date: "17-Jan-23",
      date_time: "(Tues), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -08",
      Date: "18-Jan-23",
      date_time: "(Wed), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -09",
      Date: "19-Jan-23",
      date_time: "(Thurs), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -10",
      Date: "20-Jan-23",
      date_time: "(Fri), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -11",
      Date: "21-Jan-23",
      date_time: "(Sat), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-9",
      Date: "22-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Atoms, Nuclei, Capacitors",
      Chem:"Aldehydes, Ketones and Carboxylic Acids",
      Maths: "Differential Equations,Statistics"
    },
    {
      test_name: "JEE Main Grand Test -12",
      Date: "22-Jan-23",
      date_time: "(Sun), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -13",
      Date: "23-Jan-23",
      date_time: "(Mon), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -14",
      Date: "24-Jan-23",
      date_time: "(Tues), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -15",
      Date: "25-Jan-23",
      date_time: "(Wed), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -16",
      Date: "26-Jan-23",
      date_time: "(Thurs), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -17",
      Date: "27-Jan-23",
      date_time: "(Fri), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -18",
      Date: "28-Jan-23",
      date_time: "(Sat), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-10",
      Date: "29-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Atoms, Nuclei, Capacitors",
      Chem:"Biomolecules, Polymers",
      Maths: "Sequence and Series"
    },
    {
      test_name: "JEE Main Grand Test -19",
      Date: "29-Jan-23",
      date_time: "(Sun), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-11",
      Date: "05-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Current Electricity, Moving Charges and magnetism",
      Chem:"Hydrocarbons, Aldehydes, Ketones and Carboxylic Acids, Biomolecules, Polymers, Chemistry in Everyday Life",
      Maths: "Limits, Continuity Differentiability"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-12",
      Date: "12-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Moving Charges and magnetism, Magnetism and Matter",
      Chem:"Haloalkanes and Halarenes",
      Maths: "Methods of Differentiation, Applications of derivatives"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-13",
      Date: "19-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Electromagnetic induction,Alternating Current",
      Chem:"Alcohols, Phenols, and Ethers",
      Maths: "Straight lines, Circles"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-14",
      Date: "26-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Electromagnetic Waves",
      Chem:"Amines",
      Maths: "Parabola,Eliipse and Hyperbola"
    }
  ],
  JEE_13th_ILTS:[
    {
      test_name: "JEE Rank Assurance Program ILTS-6",
      Date: "01-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Semiconductor Electronics: Materials, Devices and Simple Circuits, Communication systems",
      Chem:"GeneraI Organic Chemistry",
      Maths: "Mathematical Reasoning, Matrices and Determinants"
    },
    {
      test_name: "JEE Main Grand Test -01 ",
      Date: "03-Jan-23",
      date_time: "(Tues), 4pm to 7pm",
      Phy: "Syllabus of  Grade -XII",
      Chem: "Syllabus of  Grade -XII",
      Maths: "Syllabus of  Grade -XII"
    },
    {
      test_name: "JEE Main Grand Test -02",
      Date: "05-Jan-23",
      date_time: "(Thurs), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI",
      Chem: "Syllabus of Grade- XI",
      Maths: "Syllabus of Grade- XI"
    },
    {
      test_name: "JEE Main Grand Test -03",
      Date: "07-Jan-23",
      date_time: "(Sat), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-7",
      Date: "08-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Ray Optics and Optical Instruments",
      Chem:"GeneraI Organic Chemistry",
      Maths: "Vectors, 3D Geometry,Inverse trogonometric Functions"
    },
    {
      test_name: "JEE Main Grand Test -04",
      Date: "09-Jan-23",
      date_time: "(Mon), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -05",
      Date: "11-Jan-23",
      date_time: "(Wed), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -06",
      Date: "13-Jan-23",
      date_time: "(Fri), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-8",
      Date: "15-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Wave optics, Dual Nature of Matter and Radiation",
      Chem:"Hydrocarbons",
      Maths: "Trigonometric Equations,Defininite Integration, Areas"
    },
    {
      test_name: "JEE Main Grand Test -07",
      Date: "17-Jan-23",
      date_time: "(Tues), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -08",
      Date: "18-Jan-23",
      date_time: "(Wed), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -09",
      Date: "19-Jan-23",
      date_time: "(Thurs), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -10",
      Date: "20-Jan-23",
      date_time: "(Fri), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -11",
      Date: "21-Jan-23",
      date_time: "(Sat), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-9",
      Date: "22-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Atoms, Nuclei, Capacitors",
      Chem:"Aldehydes, Ketones and Carboxylic Acids",
      Maths: "Differential Equations,Statistics"
    },
    {
      test_name: "JEE Main Grand Test -12",
      Date: "22-Jan-23",
      date_time: "(Sun), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -13",
      Date: "23-Jan-23",
      date_time: "(Mon), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -14",
      Date: "24-Jan-23",
      date_time: "(Tues), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -15",
      Date: "25-Jan-23",
      date_time: "(Wed), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -16",
      Date: "26-Jan-23",
      date_time: "(Thurs), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -17",
      Date: "27-Jan-23",
      date_time: "(Fri), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Main Grand Test -18",
      Date: "28-Jan-23",
      date_time: "(Sat), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-10",
      Date: "29-Jan-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Atoms, Nuclei, Capacitors",
      Chem:"Biomolecules, Polymers",
      Maths: "Sequence and Series"
    },
    {
      test_name: "JEE Main Grand Test -19",
      Date: "29-Jan-23",
      date_time: "(Sun), 4pm to 7pm",
      Phy: "Syllabus of Grade- XI & XII",
      Chem: "Syllabus of Grade- XI & XII",
      Maths: "Syllabus of Grade- XI & XII"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-11",
      Date: "05-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Current Electricity, Moving Charges and magnetism",
      Chem:"Hydrocarbons, Aldehydes, Ketones and Carboxylic Acids, Biomolecules, Polymers, Chemistry in Everyday Life",
      Maths: "Limits, Continuity Differentiability"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-12",
      Date: "12-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Moving Charges and magnetism, Magnetism and Matter",
      Chem:"Haloalkanes and Halarenes",
      Maths: "Methods of Differentiation, Applications of derivatives"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-13",
      Date: "19-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Electromagnetic induction,Alternating Current",
      Chem:"Alcohols, Phenols, and Ethers",
      Maths: "Straight lines, Circles"
    },
    {
      test_name: "JEE Rank Assurance Program ILTS-14",
      Date: "26-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Electromagnetic Waves",
      Chem:"Amines",
      Maths: "Parabola,Eliipse and Hyperbola"
    }
  ],
  JEEADV_11th_ILTS:[
    { 
      test_name: "JEE Rank Assurance Program ILTS-14",
      Date: "26-Feb-23",
      date_time: "(Sun), 2pm to 5pm",
      Phy: "Electromagnetic Waves",
      Chem:"Amines",
      Maths: "Parabola,Eliipse and Hyperbola"
    }
  ],
  NEET_11th_ILTS: [
    {
      test_name: 'NEET Grade 11 B-1 ILTS-1',
      Date: '5-Jun-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical World#Basic maths',
      Chem: 'Some Basic Concepts of Chemistry',
      Bot: 'Living World',
      Zoo: 'Animal kingdom',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-1',
      Date: '11-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical World',
      Chem: 'Some Basic Concepts of Chemistry',
      Bot: 'Living World',
      Zoo: 'Animal kingdom',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-2',
      Date: '12-Jun-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Units and Measurements',
      Chem: 'Structure of Atom',
      Bot: 'Biological Classification',
      Zoo: 'Animal kingdom',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-2',
      Date: '25-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths',
      Chem: 'Some Basic Concepts of Chemistry',
      Bot: 'Biological Classification',
      Zoo: 'Animal kingdom',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-3',
      Date: '19-Jun-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Units and Measurements',
      Chem: 'Structure of Atom',
      Bot: 'Biological Classification',
      Zoo: 'Animal kingdom',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-3',
      Date: '9-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Basic Maths',
      Chem: 'Some Basic Concepts of Chemistry',
      Bot: 'Biological Classification',
      Zoo: 'Animal kingdom',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-4',
      Date: '3-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a Straight Line',
      Chem: 'Periodic Classification',
      Bot: 'Biological Classification',
      Zoo: 'Structural Organization in Animals ',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-4',
      Date: '23-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Units and Measurements',
      Chem: 'Structure of Atom',
      Bot: 'Plant Kingdom',
      Zoo: 'Structural Organi(sat)ion in Animals',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-5',
      Date: '17-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a Plane',
      Chem: 'Chemical Bonding',
      Bot: 'Plant Kingdom ',
      Zoo: 'Structural Organization in Animals ',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-5',
      Date: '31-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in Straight Line',
      Chem: 'Structure of Atom',
      Bot: 'Plant Kingdom',
      Zoo: 'Structural Organi(sat)ion in Animals',
    },
    {
      test_name: 'NEET Grade 11 B-2 CT-1',
      Date: '13-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical world.Basic Maths#Units and Measurements#Motion in a straight line',
      Chem: 'Some Basic Concepts of ChemistryStructure of Atom',
      Bot: 'Living World#Biological Classification#Plant Kingdom',
      Zoo: 'Animal KingdomStructural Organization in Animals',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-6',
      Date: '31-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion ',
      Chem: 'Chemical Bonding',
      Bot: 'Plant Kingdom ',
      Zoo: 'Biomolecules',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-6',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a Plane',
      Chem: 'Periodic Classification',
      Bot: 'Morphology of Flowering Plants',
      Zoo: 'Biomolecules',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-7',
      Date: '14-Aug-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion ',
      Chem: 'States of Matter',
      Bot: 'Morphology of Flowering Plants',
      Zoo: 'Biomolecules',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-7',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion',
      Chem: 'Periodic Classification',
      Bot: 'Anatomy of Flowering Plants',
      Zoo: 'Biomolecules',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-8',
      Date: '28-Aug-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion ',
      Chem: 'Thermo Dynamics',
      Bot: 'Morphology of Flowering Plants',
      Zoo: 'Digestion and Absorption',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-8',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Work, Energy and Power',
      Chem: 'Chemical bonding',
      Bot: 'Cell: The Unit of Life',
      Zoo: 'Digestion and Absorption',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-9',
      Date: '11-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Work, Energy and Power ',
      Chem: 'Equilibrium',
      Bot: 'Anatomy of Flowering plants',
      Zoo: 'Digestion and Absorption',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-9',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion #Gravitation',
      Chem: 'States of Matter',
      Bot: 'Cell Cycle and Cell Division',
      Zoo: 'Digestion and Absorption',
    },
    {
      test_name: 'NEET Grade 11 B-2 CT-2',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a Plane#Laws of Motion#Work, Energy and PowerSystem of Particles and Rotational Motion #Gravitation',
      Chem: 'Periodic Classification#Chemical BondingStates of Matter',
      Bot: 'Morphology of Flowering Plants#Anatomy of Flowering PlantsCell: The Unit of LifeCell Cycle and Cell Division',
      Zoo: 'Biomolecules#Digestion and Absorption',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-10',
      Date: '25-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion ',
      Chem: 'Equilibrium',
      Bot: 'Anatomy of Flowering Plants',
      Zoo: 'Breathing and Exchange of Gases',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-10',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Solids ',
      Chem: 'Thermodynamics',
      Bot: 'Transport in Plants',
      Zoo: 'Breathing and Exchange of Gases',
    },
    {
      test_name: 'NEET Grade 11 B-1  CT-1',
      Date: '9-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical World#Basic maths Units and Measurements#Motion in a Straight Line',
      Chem: 'Some Basic Concepts of Chemistry#Structure of Atom#Periodic Classification',
      Bot: 'Living World#Biological Classification#Plant Kingdom ',
      Zoo: 'Animal kingdom#Structural Organization in Animals ',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-11',
      Date: '23-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion ',
      Chem: 'Redox Reactions',
      Bot: 'Cell: The Unit of Life',
      Zoo: 'Body Fluids and Circulation',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-11',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: '#Mechanical Properties of Fluids',
      Chem: 'Equilibrium',
      Bot: 'Mineral Nutrition',
      Zoo: 'Body Fluids and Circulation',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-12',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Gravitation ',
      Chem: 'Hydrogen ',
      Bot: 'Cell Cycle and Cell Division',
      Zoo: 'Body Fluids and Circulation',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-12',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermal Properties of Matter',
      Chem: 'Redox Reactions,Hydrogen',
      Bot: 'Photosynthesis in Higher',
      Zoo: 'Excretory Products and Their Elimination',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-13',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Solids ',
      Chem: 'S-Block',
      Bot: 'Transport in Plants',
      Zoo: 'Excretory Products and Their Elimination',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-13',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermodynamics',
      Chem: 'S-Block #P-Block',
      Bot: 'Photosynthesis in Higher',
      Zoo: 'Locomotion and Movement',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-14',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Solids ',
      Chem: 'P-Block',
      Bot: 'Transport in Plants',
      Zoo: 'Excretory Products and Their Elimination',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-14',
      Date: '12-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Kinetic Theory',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Respoiration in Plants',
      Zoo: 'Neural Control and Coordination',
    },
    {
      test_name: 'NEET Grade 11 B-1 CT-2',
      Date: '11-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion #Gravitation #Mechanical Properties of Solids ',
      Chem: 'Redox Reactions#Hydrogen S-Block#P-Block',
      Bot: 'Cell: The Unit of Life#Cell Cycle and Cell Division',
      Zoo: 'Body Fluids and Circulation#Excretory Products and Their Elimination',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-15',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Fluids ',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Mineral Nutrition ',
      Zoo: 'Locomotion and Movement',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-15',
      Date: '26-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Oscillations',
      Chem: 'Hydrocarbons',
      Bot: 'Respoiration in Plants',
      Zoo: 'Neural Control and Coordination',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-16',
      Date: '25-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermal Properties of Matter ',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Photosynthesis in higher plants',
      Zoo: 'Locomotion and Movement',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-16',
      Date: '9-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: ' Waves',
      Chem: 'Environmental Chemistry',
      Bot: 'Plant Growth and Development',
      Zoo: 'Chemical Coordination and Integration',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-17',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermodynamics ',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Photosynthesis in higher plants',
      Zoo: 'Neural Control and Coordination',
    },
    {
      test_name: 'NEET Grade 11 B-2 CT-3',
      Date: '16-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Solids #Mechanical Properties of Fluids#Thermal Properties of Matter#Thermodynamics#Kinetic Theory#Oscillations #Waves',
      Chem: 'Thermodynamics,Equilibrium#Redox Reactions#HydrogenS-Block #P-Block#Organic Chemistry- Some basic principles and techniques(General Organic)#Hydrocarbons#Environmental Chemistry',
      Bot: 'Transport in Plants#Mineral Nutrition#Photosynthesis in HigherRespoiration in Plants#Plant Growth and Development',
      Zoo: 'Breathing and Exchange of Gases#Body Fluids and Circulation#Excretory Products and Their Elimination#Locomotion and Movement#Neural Control and Coordination#Chemical Coordination and Integration',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-17',
      Date: '19-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical World#Basic MathsBasic MathsUnits and Measurements#Motion in Straight LineMotion in a PlaneLaws of MotionWork, Energy and Power',
      Chem: 'Some Basic Concepts of Chemistry#Structure of Atom#Periodic Classification#Chemical bonding',
      Bot: 'Living World#Biological Classification#Biological Classification#Plant Kingdom#Morphology of Flowering PlantsAnatomy of Flowering PlantsCell: The Unit of Life',
      Zoo: 'Animal kingdom#Structural Organi(sat)ion in Animals#Biomolecules#Digestion and Absorption',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-18',
      Date: '22-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Kinetic Theory ',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Respiration in Plants ',
      Zoo: 'Neural Control and Coordination',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-18',
      Date: '23-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion Gravitation#Mechanical Properties of Solids Mechanical Properties of FluidsThermal Properties of Matter#ThermodynamicsKinetic TheoryOscillationsWaves',
      Chem: 'States of Matter#Thermodynamics#Equilibrium#Redox Reactions,HydrogenS-Block #P-BlockOrganic Chemistry- Some basic principles and techniques(General Organic)HydrocarbonsEnvironmental Chemistry',
      Bot: 'Cell Cycle and Cell Division#Transport in Plants#Mineral Nutrition#Photosynthesis in HigherPhotosynthesis in HigherRespoiration in Plants#Respoiration in Plants#Plant Growth and Development',
      Zoo: 'Breathing and Exchange of Gases#Body Fluids and Circulation#Excretory Products and Their Elimination#Locomotion and Movement#Neural Control and Coordination#Chemical Coordination and Integration#Chemical Coordination and Integration',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-19',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Oscillations ',
      Chem: 'Hydrocarbons',
      Bot: 'Transport in Plants#Mineral Nutrition ',
      Zoo: 'Chemical Coordination and Integration',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-19',
      Date: '26-Apr-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-20',
      Date: '5-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Waves ',
      Chem: 'Environmental Chemistry',
      Bot: 'Plant Growth and Development',
      Zoo: 'Chemical Coordination and Integration',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-20',
      Date: '30-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'NEET Grade 11 B-1 CT-3',
      Date: '19-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Fluids Thermal Properties of Matter Thermodynamics Kinetic Theory Oscillations Waves ',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)HydrocarbonsEnvironmental Chemistry',
      Bot: 'Photosynthesis in higher plants#Respoiration in Plants Plant Growth and Development',
      Zoo: 'Locomotion and Movement#Neural Control and Coordination#Chemical Coordination and Integration',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-21',
      Date: '5-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical World#Basic maths#Units and MeasurementsMotion in a Straight Line#Motion in a PlaneLaws of Motion Work, Energy and Power ',
      Chem: 'Some Basic Concepts of Chemistry#Structure of AtomPeriodic Classification#Chemical BondingStates of Matter#Thermo DynamicsEquilibrium',
      Bot: 'Living World#Biological Classification#Plant Kingdom Morphology of Flowering Plants#Anatomy of Flowering plants',
      Zoo: 'Animal kingdom#Biomolecules#Digestion and Absorption#Breathing and Exchange of Gases',
    },
    {
      test_name: 'NEET Grade 11 B-2 ILTS-21',
      Date: '3-May-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-22',
      Date: '12-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'System of Particles and Rotational Motion Gravitation Mechanical Properties of Solids Mechanical Properties of Fluids Thermal Properties of Matter ',
      Chem: 'Redox Reactions#Hydrogen S-BlockP-BlockOrganic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Cell: The Unit of LifeCell Cycle and Cell Division#Transport in Plants#Mineral Nutrition #Photosynthesis in higher plants',
      Zoo: 'Body Fluids and Circulation#Excretory Products and Their Elimination#Locomotion and Movement#Neural Control and Coordination',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-23',
      Date: '19-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermodynamics Kinetic Theory Oscillations Waves ',
      Chem: 'Hydrocarbons#Environmental Chemistry',
      Bot: 'Respiration in Plants Transport in Plants#Mineral Nutrition#Plant Growth and Development',
      Zoo: 'Chemical Coordination and Integration',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-24',
      Date: '26-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-25',
      Date: '2-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-26',
      Date: '9-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
    {
      test_name: 'NEET Grade 11 B-1 ILTS-27',
      Date: '16-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Full XI Syllabus',
    },
  ],
  NEET_12th_ILTS: [
    {
      test_name: 'NEET Grade 12 B-1 ILTS-1',
      Date: '5-Jun-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields',
      Chem: 'Solid State ',
      Bot: 'Reproduction in Organisms',
      Zoo: 'Human Reproduction ',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-1',
      Date: '11-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields',
      Chem: 'Solid State',
      Bot: 'Reproduction in Organisms',
      Zoo: 'Human Reproduction',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-2',
      Date: '12-Jun-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields',
      Chem: 'Solutions',
      Bot: 'Sexual Reproduction in Flowering Plants',
      Zoo: 'Human Reproduction ',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-2',
      Date: '25-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance',
      Chem: 'Solutions',
      Bot: 'Reproduction in Organisms',
      Zoo: 'Human Reproduction',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-3',
      Date: '19-Jun-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance',
      Chem: 'Solutions',
      Bot: 'Sexual Reproduction in Flowering Plants',
      Zoo: 'Human Reproduction ',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-3',
      Date: '9-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance',
      Chem: 'Electro Chemistry',
      Bot: 'Sexual Reproduction in Flowering Plants',
      Zoo: 'Reproductive Health',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-4',
      Date: '26-Jun-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance',
      Chem: 'Electro chemistry',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Reproductive Health',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-4',
      Date: '23-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance',
      Chem: 'Electro Chemistry',
      Bot: 'Sexual Reproduction in Flowering Plants',
      Zoo: 'Human Reproduction',
    },
    {
      test_name: 'NEET Grade 12  B-2 CT-1',
      Date: '30-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields#Electrostatic Potential and Capacitance',
      Chem: 'Solid StateSolutions#Electro chemistry',
      Bot: 'Reproduction in Organisms#Sexual Reproduction in Flowering Plants',
      Zoo: 'Human Reproduction and reproductive health',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-5',
      Date: '3-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance',
      Chem: 'Electro chemistry',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Reproductive Health',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-5',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'Chemical kinetics',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Evolution',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-6',
      Date: '10-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'Chemical kinetics',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Reproductive Health',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-6',
      Date: '13-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'Surface chemistry',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Evolution',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-7',
      Date: '17-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'Chemical kinetics',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Evolution',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-7',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Moving Charges and magnetism',
      Chem: 'General Principles and processes of Isolation of Elements',
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Human Reproduction',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-8',
      Date: '24-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'Surface chemistry',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Evolution',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-8',
      Date: '27-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Moving Charges and magnetism',
      Chem: 'P-Block',
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Human Reproduction',
    },
    {
      test_name: 'NEET Grade 12  B-2 CT-2',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity#Moving Charges and magnetism',
      Chem: 'Chemical kinetics#Surface chemistry#General Principles and processes of Isolation of ElementsP-Block',
      Bot: 'Principles of Inheritance and Variation#Molecular Basis of Inheritance',
      Zoo: 'Human Reproduction, Reproductive Health and evolution',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-9',
      Date: '31-Jul-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'General Principles and processes of Isolation  ',
      Bot: 'Principles of Inheritance and Variation',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-9',
      Date: '11-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Magnetism and Matter',
      Chem: "d' and 'f' block elements",
      Bot: 'Strategies for Enhancement in Food Production',
      Zoo: 'Evolution',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-10',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'P-Block',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Human Health & Disease',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-10',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Magnetism and Matter',
      Chem: 'Coordination Compounds',
      Bot: 'Strategies for Enhancement in Food Production',
      Zoo: 'Human Health & Diseases',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-11',
      Date: '14-Aug-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Moving Charges and magnetism',
      Chem: 'P-Block',
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Human Health & Disease',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-11',
      Date: '25-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic induction',
      Chem: 'Haloalkanes and Haloarenes',
      Bot: 'Microbes in Human Welfare',
      Zoo: 'Human Health & Diseases',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-12',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Moving Charges and magnetism',
      Chem: 'P-Block',
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Human Health & Disease',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-12',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic induction',
      Chem: 'Haloalkanes and Haloarenes',
      Bot: 'Microbes in Human Welfare',
      Zoo: 'Human Health & Diseases',
    },
    {
      test_name: 'NEET Grade 11  B-2  CT-3',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Magnetism and Matter#Electromagnetic induction',
      Chem: 'Coordination Compounds#Haloalkanes and Haloarenes',
      Bot: 'Strategies for Enhancement in Food Production#Microbes in Human Welfare',
      Zoo: 'Human Health & Diseases and evolution',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-13',
      Date: '28-Aug-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Moving Charges and magnetism',
      Chem: "d' and 'f' block elements",
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Human Health & Disease',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-13',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Alternating Current',
      Chem: 'Alcohols, Phenols and Ethers',
      Bot: 'Organisms and Populations',
      Zoo: 'Animal Husbandry',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-14',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Magnetism and Matter',
      Chem: 'Coordination Compounds',
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Animal Husbandry ',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-14',
      Date: '22-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Alternating Current',
      Chem: 'Alcohols, Phenols and Ethers',
      Bot: 'Organisms and Populations',
      Zoo: 'Human Reproduction',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-15',
      Date: '11-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Magnetism and Matter',
      Chem: 'Coordination Compounds',
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Animal Husbandry ',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-15',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Alternating Current',
      Chem: 'Aldehydes, Ketones and Carboxylic acids',
      Bot: 'Ecosystem',
      Zoo: 'Reproductive Health ',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-16',
      Date: '18-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Magnetism and Matter',
      Chem: 'Coordination Compounds',
      Bot: 'Molecular Basis of Inheritance',
      Zoo: 'Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-16',
      Date: '5-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic Waves',
      Chem: 'Aldehydes, Ketones and Carboxylic acids',
      Bot: 'Ecosystem',
      Zoo: 'Evolution',
    },
    {
      test_name: 'NEET Grade 11  B-2  CT-4',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Alternating Current#Electromagnetic Waves',
      Chem: 'Alcohols, Phenols and Ethers#Aldehydes, Ketones and Carboxylic acids',
      Bot: 'Organisms and PopulationsEcosystem',
      Zoo: 'Animal Husbandry, Human health and disease',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-17',
      Date: '25-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic induction',
      Chem: 'Haloalkanes',
      Bot: 'Strategies for Enhancement in Food Production',
      Zoo: 'Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-17',
      Date: '19-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Ray Optics & Optical Instruments',
      Chem: 'Amines',
      Bot: 'Biodiversity and Conservation',
      Zoo: 'Biotechnology : Principles & Processes',
    },
    {
      test_name: 'NEET Grade 12  B1  CT-1',
      Date: '2-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields#Electrostatic Potential and Capacitance ',
      Chem: 'Solid StateSolutions#Electro chemistryChemical kinetics#Surface chemistry',
      Bot: 'Reproduction in OrganismsSexual Reproduction in Flowering Plants',
      Zoo: 'Human Reproduction#Reproductive HealthEvolution',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-18',
      Date: '9-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic induction',
      Chem: 'Haloalkanes',
      Bot: 'Microbes in Human Welfare- Complete Chapter',
      Zoo: 'Human Reproduction -  (Full Chapter)',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-18',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Wave optics',
      Chem: 'Biomolecules',
      Bot: 'Biodiversity and Conservation',
      Zoo: 'Biotechnology : Principles & Processes',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-19',
      Date: '16-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Alternating Current',
      Chem: ' Haloarenes',
      Bot: 'Organisms and Populations',
      Zoo: 'Reproductive Health',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-19',
      Date: '5-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Dual Nature of Matter and Radiation',
      Chem: 'Biomolecules',
      Bot: 'Biodiversity and Conservation',
      Zoo: 'Biotechnology : Principles & Processes',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-20',
      Date: '23-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Alternating Current',
      Chem: ' Haloarenes',
      Bot: 'Organisms and Populations',
      Zoo: 'Reproductive Health',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-20',
      Date: '12-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'AtomsNuclei',
      Chem: 'Polymers',
      Bot: 'Environmental Issues',
      Zoo: 'Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-21',
      Date: '30-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic Waves',
      Chem: 'Haloalkanes and Haloarenes',
      Bot: 'Organisms and Populations',
      Zoo: 'Reproductive Health',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-21',
      Date: '19-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Chemistry In Everyday life',
      Bot: 'Environmental Issues',
      Zoo: 'Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-1 CT-2',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity#Moving Charges and magnetism#Magnetism and Matter#Electromagnetic inductionAlternating CurrentElectromagnetic Waves',
      Chem: "General Principles and processes of Isolation of Elements#P-Blockd' and 'f' block elements#Coordination Compounds#Haloalkanes and Haloarenes",
      Bot: 'Principles of Inheritance and VariationMolecular Basis of InheritanceStrategies for Enhancement in Food ProductionMicrobes in Human Welfare',
      Zoo: 'Human Reproduction # Reproductive Health',
    },
    {
      test_name: 'NEET Grade 11  B-2  CT-5',
      Date: '26-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Ray Optics & Optical Instruments#Wave opticsDual Nature of Matter and Radiation#AtomsNuclei#Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'AminesBiomolecules#Polymers#Chemistry In Everyday life',
      Bot: 'Biodiversity and Conservation#Environmental Issues',
      Zoo: 'Biotechnology : Principles & Processes#Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-22',
      Date: '13-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Ray Optics & Optical Instruments ',
      Chem: 'Alcohols, Phenols and Ethers',
      Bot: 'Ecosystem',
      Zoo: 'Human Health & Diseases',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-22',
      Date: '2-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields#Electrostatic Potential and Capacitance#Current Electricity#Moving Charges and magnetism#Magnetism and Matter',
      Chem: "Solid StateSolutions#Electro Chemistry#Chemical kinetics#Surface chemistry#General Principles and processes of Isolation of ElementsP-Blockd' and 'f' block elements#Coordination Compounds",
      Bot: 'Reproduction in Organisms#Sexual Reproduction in Flowering Plants#Principles of Inheritance and Variation#Molecular Basis of Inheritance#Strategies for Enhancement in Food Production',
      Zoo: 'Human Reproduction#Reproductive HealthEvolution',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-23',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Ray Optics & Optical Instruments ',
      Chem: 'Alcohols, Phenols and Ethers',
      Bot: 'Ecosystem',
      Zoo: 'Human Health & Diseases',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-23',
      Date: '5-Apr-23',
      date_time: 'Wed, 2pm to 5pm',
      Phy: 'Electromagnetic induction#Alternating Current#Electromagnetic WavesRay Optics & Optical InstrumentsWave optics#Dual Nature of Matter and Radiation"AtomsNuclei"Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Haloalkanes and HaloarenesAlcohols, Phenols and EthersAldehydes, Ketones and Carboxylic acidsAmines#Biomolecules#PolymersChemistry In Everyday life',
      Bot: 'Microbes in Human Welfare#Organisms and Populations#Ecosystem#Biodiversity and Conservation#Environmental Issues',
      Zoo: 'Human Health & Diseases#Animal Husbandry#Biotechnology : Principles & Processes#Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-24',
      Date: '27-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Wave optics ',
      Chem: 'Alcohols, Phenols and Ethers',
      Bot: 'Biodiversity and Conservation',
      Zoo: 'Animal Husbandry #Human Health & Diseases',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-24',
      Date: '9-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-25',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Wave optics ',
      Chem: 'Alcohols, Phenols and Ethers',
      Bot: 'Biodiversity and Conservation',
      Zoo: 'Animal Husbandry #Human Health & Diseases',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-25',
      Date: '12-Apr-23',
      date_time: 'Wed, 2pm to 5pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'NEET Grade 12  B-1 CT-3',
      Date: '11-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Ray Optics & Optical Instruments Wave optics ',
      Chem: 'Haloalkanes and Haloarenes#Alcohols, Phenols and Ethers',
      Bot: 'Organisms and Populations#Ecosystem, Biodiversity and Conservation',
      Zoo: 'Human Health & DiseasesAnimal Husbandry',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-26',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Dual Nature of Matter and Radiation ',
      Chem: 'Aldehydes, Ketones and Carboxylic acids',
      Bot: 'Environmental Issues',
      Zoo: 'Biotechnology : Principles & Processes',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-26',
      Date: '16-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-27',
      Date: '25-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Dual Nature of Matter and Radiation ',
      Chem: 'Aldehydes, Ketones and Carboxylic acids',
      Bot: 'Environmental Issues',
      Zoo: 'Biotechnology : Principles & Processes',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-27',
      Date: '19-Apr-23',
      date_time: 'Wed, 2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-28',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Atoms ',
      Chem: 'Amines',
      Bot: 'Microbes in Human Welfare# Ecosystem',
      Zoo: 'Biotechnology : Principles & Processes',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-28',
      Date: '23-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-29',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Nuclei ',
      Chem: 'Biomolecules',
      Bot: 'Environmental Issues # Biodiversity and Conservation',
      Zoo: 'Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-29',
      Date: '26-Apr-23',
      date_time: 'Wed, 2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-30',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Polymers',
      Bot: 'Environmental Issues #Organisms and Populations',
      Zoo: 'Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-2 ILTS-30',
      Date: '30-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-31',
      Date: '22-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Chemistry In Everyday life',
      Bot: 'Environmental Issues #Organisms and Populations',
      Zoo: 'Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12  B-1  CT-4',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Dual Nature of Matter and Radiation Atoms Nuclei Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Aldehydes, Ketones and Carboxylic acidsAldehydes, Ketones and Carboxylic acids#Amines#Biomolecules#Polymers#Chemistry In Everyday life',
      Bot: 'Biodiversity and Conservation#Environmental Issues',
      Zoo: 'Biotechnology : Principles & ProcessesBiotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-32',
      Date: '5-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields#Electrostatic Potential and Capacitance#Current Electricity',
      Chem: 'Solid State Solutions#Electro chemistry#Chemical kineticsSurface chemistry#General Principles and processes of Isolation  P-Block',
      Bot: 'Reproduction in Organisms#Sexual Reproduction in Flowering PlantsPrinciples of Inheritance and Variation',
      Zoo: 'Human Reproduction Reproductive Health#EvolutionHuman Health & Disease',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-33',
      Date: '8-Feb-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Moving Charges and magnetism#Magnetism and Matter#Electromagnetic induction#Alternating Current#Electromagnetic Waves',
      Chem: "d' and 'f' block elements#Coordination Compounds#Haloalkanes and Haloarenes",
      Bot: 'Molecular Basis of Inheritance#Strategies for Enhancement in Food Production#Microbes in Human Welfare- Complete ChapterOrganisms and Populations',
      Zoo: 'Animal Husbandry Biotechnology & its application',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-34',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Ray Optics & Optical Instruments Wave optics Dual Nature of Matter and Radiation Atoms Nuclei Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Alcohols, Phenols and Ethers#Aldehydes, Ketones and Carboxylic acids#Amines#Biomolecules#Polymers#Chemistry In Everyday life',
      Bot: 'Ecosystem#Biodiversity and Conservation#Environmental Issues#Microbes in Human Welfare# Ecosystem#Environmental Issues # Biodiversity and Conservation',
      Zoo: 'Animal Husbandry Human Health & DiseasesBiotechnology : Principles & Processes',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-35',
      Date: '15-Feb-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-36',
      Date: '19-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-37',
      Date: '22-Feb-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-38',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-39',
      Date: '1-Mar-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'NEET Grade 12 B-1 ILTS-40',
      Date: '6-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
  ],
  NEET_13th_ILTS: [
    {
      test_name: 'Rank Assurance Program Test Series-1',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical World#Basic Maths',
      Chem: 'Some Basic Concepts of Chemistry',
      Bot: 'The Living World',
      Zoo: 'Animal Kingdom',
    },
    {
      test_name: 'Rank Assurance Program Test Series-2',
      Date: '18-Sep-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Unit Dimension Errors and Instruments',
      Chem: 'Structure of Atom',
      Bot: 'Biological Classification',
      Zoo: 'Animal Kingdom',
    },
    {
      test_name: 'Rank Assurance Program Test Series-3',
      Date: '2-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a straight line',
      Chem: 'Periodic Classification',
      Bot: 'Plant Kingdom',
      Zoo: 'Structural Organi(sat)ion in Animals',
    },
    {
      test_name: 'Rank Assurance Program Test Series-4',
      Date: '16-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a straight line',
      Chem: 'Some Basic Concepts of Chemistry',
      Bot: 'The Living World',
      Zoo: 'Structural Organi(sat)ion in Animals',
    },
    {
      test_name: 'Rank Assurance Program Test Series-5',
      Date: '23-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Motion in a Plane',
      Chem: 'States of Matter',
      Bot: 'Biological Classification',
      Zoo: 'Biomolecules',
    },
    {
      test_name: 'Rank Assurance Program Test Series-6',
      Date: '30-Oct-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Laws of Motion',
      Chem: 'Thermo Dynamics & Chemical Equilibrium',
      Bot: 'Morphology of flowering plants',
      Zoo: 'Biomolecules',
    },
    {
      test_name: 'Rank Assurance Program   CT-1',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Physical World#Basic Maths#Unit Dimension Errors and Instruments#Motion in a straight line#Motion in a straight line#Motion in a Plane#Laws of Motion',
      Chem: 'Some Basic Concepts of Chemistry#Structure of Atom#Periodic Classification#States of Matter#Thermo Dynamics & Chemical Equilibrium',
      Bot: 'The Living World#Biological Classification#Plant KingdomThe Living World#Biological Classification#Morphology of flowering plants',
      Zoo: 'Animal Kingdom#Structural Organi(sat)ion in Animals, Biomolecules',
    },
    {
      test_name: 'Rank Assurance Program Test Series-7',
      Date: '13-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Friction Work, Energy and Power',
      Chem: 'Ionic Equilibrium & Redox Reaction ',
      Bot: 'Anatomy of Flowering Plants',
      Zoo: 'Digestion and Absorption',
    },
    {
      test_name: 'Rank Assurance Program Test Series-8',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Circular Motion#Centre of MassCollision',
      Chem: 'Hydrogen & s - Block',
      Bot: 'Cell: The Unit of Life ',
      Zoo: 'Digestion and Absorption',
    },
    {
      test_name: 'Rank Assurance Program Test Series-9',
      Date: '27-Nov-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Rotational Mechanics',
      Chem: 'p block',
      Bot: 'Cell Cycle and Cell Division',
      Zoo: 'Breathing and exchange of gases',
    },
    {
      test_name: 'Rank Assurance Program Test Series-10',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Gravitation',
      Chem: 'Organic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Transport In Plants',
      Zoo: 'Breathing and exchange of gases',
    },
    {
      test_name: 'Rank Assurance Program   CT-2',
      Date: '11-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'FrictionWork, Energy and Power#Circular Motion#Centre of Mass#Collision#Rotational Mechanics#Gravitation',
      Chem: 'Ionic Equilibrium & Redox Reaction Hydrogen & s - Blockp block#Organic Chemistry- Some basic principles and techniques(General Organic)',
      Bot: 'Anatomy of Flowering PlantsCell: The Unit of Life #Biomolecules#Cell Cycle and Cell Division#Transport In Plants',
      Zoo: 'Digestion and Absorption, Breathing and exchange of gases',
    },
    {
      test_name: 'Rank Assurance Program Test Series-11',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Solids#Mechanical Properties of Fluids',
      Chem: 'Hydrocarbons',
      Bot: 'Mineral Nutrition',
      Zoo: 'Bodyfluids and their circulation',
    },
    {
      test_name: 'Rank Assurance Program Test Series-12',
      Date: '25-Dec-22',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Calorimetry#Thermal expansion#Heat Transfer#Kinetic Theory Of Gases',
      Chem: 'Environmental Chemistry & Solid State',
      Bot: 'Photosynthesis in Higher Plants',
      Zoo: 'Excretory products and their elimination',
    },
    {
      test_name: 'Rank Assurance Program Test Series-13',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Thermodynamics#OscillationsWaves',
      Chem: 'Solution and Colligative Property',
      Bot: 'Respiration in Plants',
      Zoo: 'Locomotion and movement',
    },
    {
      test_name: 'Rank Assurance Program Test Series-14',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electric Charges and Fields',
      Chem: 'Electrochemistry',
      Bot: 'Reproduction in Organisms #Plant Growth and Development',
      Zoo: 'Neural control and coordination',
    },
    {
      test_name: 'Rank Assurance Program   CT-3',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Mechanical Properties of Solids#Mechanical Properties of Fluids#Calorimetry#Thermal expansion#Heat Transfer#Kinetic Theory Of Gases#Thermodynamics#Oscillations#Waves#Electric Charges and Fields',
      Chem: 'Hydrocarbons#Environmental Chemistry Solid State#Solution and Colligative Property#Electrochemistry',
      Bot: 'Mineral Nutrition#Photosynthesis in Higher Plants#Respiration in Plants#Reproduction in Organisms #Plant Growth and Development',
      Zoo: 'Body Fluids and Circulation#Excretory Products and Their Elimination#Locomotion and Movement#Neural control and coordination',
    },
    {
      test_name: 'Rank Assurance Program Test Series-15',
      Date: '22-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance',
      Chem: 'Chemical Kinetics',
      Bot: 'Sexual Reproduction in Flowering Plants',
      Zoo: 'Chemical control and integration',
    },
    {
      test_name: 'Rank Assurance Program Test Series-16',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Current Electricity',
      Chem: 'Surface Chemistry & Metallurgy',
      Bot: 'Principles of Inheritance and Variation',
      Zoo: 'Human reproduction',
    },
    {
      test_name: 'Rank Assurance Program Test Series-17',
      Date: '5-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Moving Charges and Magnetic Field#Magnetism and Matter',
      Chem: 'Coordination Compound & d & f Block Element',
      Bot: 'Molecular Basis of Inheritance ',
      Zoo: 'Reproductive health',
    },
    {
      test_name: 'Rank Assurance Program Test Series-18',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic induction#Alternating Current',
      Chem: 'Haloalkane & Haloarene & Alcohol, Phenol and Ether',
      Bot: 'Strategies for Enhancement in Food Production#Microbes in Human Welfare',
      Zoo: 'Evolution',
    },
    {
      test_name: 'Rank Assurance Program CT-4',
      Date: '19-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electrostatic Potential and Capacitance#Current Electricity#Moving Charges and Magnetic Field#Magnetism and Matter#Electromagnetic induction#Alternating Current',
      Chem: 'Chemical Kinetics#Surface Chemistry & Metallurgy#Coordination Compound & d & f Block Element#Haloalkane & Haloarene & Alcohol, Phenol and Ether',
      Bot: 'Sexual Reproduction in Flowering Plants#Principles of Inheritance and Variation#Molecular Basis of Inheritance Strategies for Enhancement in Food Production#Microbes in Human Welfare',
      Zoo: 'Chemical control and integration, Human Reproduction, Reproductive Health, Evolution',
    },
    {
      test_name: 'Rank Assurance Program Test Series-19',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic Waves#Ray Optics & Optical Instruments',
      Chem: 'Carbonyl Compounds and Carboxylic acid ',
      Bot: 'Biotechnology: Principles and Processes# Organism and Population ',
      Zoo: 'Human Health and disease',
    },
    {
      test_name: 'Rank Assurance Program Test Series-20',
      Date: '5-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Wave optics#Dual Nature of Matter and Radiation',
      Chem: ' Amines & Biomolecules ',
      Bot: '#Ecosystem',
      Zoo: 'Animal Husbandry, Biotechnology:Principle and Processes',
    },
    {
      test_name: 'Rank Assurance Program Test Series-21',
      Date: '12-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'AtomsNuclei#Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Polymers, Chemistry In Everyday life ',
      Bot: 'Biodiversity and Conservation  Environmental Issues',
      Zoo: " Biotechnology and it's application",
    },
    {
      test_name: 'Rank Assurance Program CT-4',
      Date: '19-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Electromagnetic WavesRay Optics & Optical InstrumentsWave optics#Dual Nature of Matter and Radiation#AtomsNuclei#Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Carbonyl Compounds and Carboxylic acid  Amines & Biomolecules Polymers, Chemistry In Everyday life ',
      Bot: 'Biotechnology: Principles and Processes# Organism and Population #EcosystemBiodiversity and Conservation#Environmental Issues',
      Zoo: "Human Health and Disease, Animal Husbandry,Biotechnology:aprinciples and processes, Biotechnology and it's application",
    },
    {
      test_name: 'Rank Assurance Program Test Series-22',
      Date: '22-Mar-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of ILTS  1 to 10',
    },
    {
      test_name: 'Rank Assurance Program Test Series-23',
      Date: '26-Mar-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of ILTS  11 to 21',
    },
    {
      test_name: 'Rank Assurance Program Test Series-24',
      Date: '29-Mar-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of XI',
    },
    {
      test_name: 'Rank Assurance Program Test Series-25',
      Date: '2-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XI',
    },
    {
      test_name: 'Rank Assurance Program Test Series-26',
      Date: '5-Apr-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'Rank Assurance Program Test Series-27',
      Date: '9-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'Rank Assurance Program Test Series-28',
      Date: '12-Apr-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'Rank Assurance Program Test Series-29',
      Date: '16-Apr-23',
      date_time: '(Sun), 2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
    {
      test_name: 'Rank Assurance Program Test Series-30',
      Date: '19-Apr-23',
      date_time: 'Wed,2pm to 5pm',
      Phy: 'Syllabus of XI+XII',
    },
  ],
  CBSE_G6: [
    {
      test_name: 'CBSE Grade 6 AICBTS-1 ',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Food : Where Does It Come From ? Components Of Food Fibre To Fabric Sorting Materials Into Groups  Separation Of Substances',
      Maths: 'Knowing Our Numbers Whole Numbers',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-2',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Changes Around Us Getting To Know Plants',
      Maths: 'Playing with Numbers',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-3',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Food where does it come from Components of food Fibre to fabric Sorting material into groups Separation Of Substances',
      Maths: 'Basic Geometrical Ideas',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-4',
      Date: '18-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Body Movements The Living Organisms -Characteristics & Habitats Motion and Measurement of Distances ',
      Maths: 'Understanding Elementary Shapes',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-5',
      Date: '2-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Types of motion  Light ,Shadows and Reflections  Changes around us  Getting to know plants',
      Maths: 'Integers Fractions',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-6',
      Date: '16-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Body movements Light, shadow and reflections Electricity and Circuits',
      Maths: 'Decimals ',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-7',
      Date: '30-Oct-22',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Water',
      Maths: 'Data Handling',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-8',
      Date: '13-Nov-22',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Fun with Magnets',
      Maths: 'Mensuration',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-9',
      Date: '27-Nov-22',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science:
        'The Living Organisms - Characteristics And Habitats  motion and measurement of distances  Light ,Shadows and Reflections Electricity and circuits ',
      Maths: 'Algebra',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-10',
      Date: '11-Dec-22',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Air Around Us',
      Maths: 'Ratio and Proportion',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-11',
      Date: '25-Dec-22',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Garbage In, Garbage Out',
      Maths: 'Symmetry ',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-12',
      Date: '8-Jan-23',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Air Around Us Garbage In, Garbage Out',
      Maths: 'Practical Geometry',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-13',
      Date: '22-Jan-23',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-14',
      Date: '5-Feb-23',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-15',
      Date: '19-Feb-23',
      date_time: '(Sun), 3:30pm - 4:30pm',
      Science: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-1 ',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Knowing Our Numbers Whole Numbers',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-2',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Playing with Numbers',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-3',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Basic Geometrical Ideas',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-4',
      Date: '18-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Understanding Elementary Shapes',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-5',
      Date: '2-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Integers Fractions',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-6',
      Date: '16-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Decimals ',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-7',
      Date: '30-Oct-22',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Data Handling',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-8',
      Date: '13-Nov-22',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Mensuration',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-9',
      Date: '27-Nov-22',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Algebra',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-10',
      Date: '11-Dec-22',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Ratio and Proportion',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-11',
      Date: '25-Dec-22',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Symmetry',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-12',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Practical Geometry',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-13',
      Date: '22-Jan-23',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-14',
      Date: '5-Feb-23',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 6 AICBTS-15',
      Date: '19-Feb-23',
      date_time: '(Sun), 2pm to 3pm',
      Maths: 'Full Syllabus',
    },
  ],
  CBSE_G7: [
    {
      test_name: 'CBSE Grade 7 AICBTS-1 ',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Nutrition In Plants Nutrition In Animals Fibre To Fabric Heat Acids, Bases And Salts',
      Maths: 'Integers',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-2',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Physical And Chemical Changes Weather, Climate and Adaptations Of Animals ',
      Maths: 'Fractions and Decimals',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-3',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Winds,Storms and Cyclones Nutrition of Plants Nutrition of Animals Fibre to Fabric Heat',
      Maths: 'Data Handling',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-4',
      Date: '18-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Respiration In Organisms Soil',
      Maths: 'Simple equation',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-5',
      Date: '2-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Motion and Time physical and chemical changes and weather climate and adaptation of animals Wind storm and cyclones respiration in organisms soil',
      Maths: ' Lines and Angles Triangle and its properties ',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-6',
      Date: '16-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Electric current and its Effects',
      Maths: 'Congruence of Triangles',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-7',
      Date: '30-Oct-22',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Transportation In Animals And Plants ',
      Maths: 'Comparing Quantities',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-8',
      Date: '13-Nov-22',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Transportation In Animals And Plants',
      Maths: 'Rational Numbers Practical Geometry',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-9',
      Date: '27-Nov-22',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Reproduction In Plants',
      Maths: 'Perimeter and Area',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-10',
      Date: '11-Dec-22',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Light',
      Maths: 'Algebraic Expressions',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-11',
      Date: '25-Dec-22',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Water : A Precious Resource',
      Maths: 'Exponents and Powers',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-12',
      Date: '8-Jan-23',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Forests : Our Life Line Waste Water Story',
      Maths: 'Symmetry Visualising Solid Shapes',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-13',
      Date: '22-Jan-23',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-14',
      Date: '5-Feb-23',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-15',
      Date: '19-Feb-23',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS-16',
      Date: '5-Mar-23',
      date_time: '(Sun), 3:30pm to 4:30pm',
      Science: 'Full Syllabus',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 1',
      Date: '7-Aug-22',
      date_time: '(Sun),  2:00PM- 3:30PM',
      Maths: 'Integers',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 2',
      Date: '21-Aug-22',
      date_time: '(Sun),  2:00PM- 3:30PM',
      Maths: 'Fractions and Decimals',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 3',
      Date: '4-Sep-22',
      date_time: '(Sun),  2:00PM- 3:30PM',
      Maths: 'Data Handling',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 4',
      Date: '18-Sep-22',
      date_time: '(Sun),  2:00PM- 3:30PM',
      Maths: 'Simple equation',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 5',
      Date: '2-Oct-22',
      date_time: '(Sun),  2:00PM- 3:30PM',
      Maths: ' Lines and Angles Triangle and its properties ',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 6',
      Date: '16-Oct-22',
      date_time: '(Sun),  2:00PM- 3:30PM',
      Maths: 'Congruence of Triangles',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 7',
      Date: '30-Oct-22',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Comparing Quantities',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 8',
      Date: '13-Nov-22',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Rational Numbers Practical Geometry',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 9',
      Date: '27-Nov-22',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Perimeter and Area',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 10',
      Date: '11-Dec-22',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Algebraic Expressions',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 11',
      Date: '25-Dec-22',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Exponents and Powers',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 12',
      Date: '8-Jan-23',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Symmetry Visualising Solid Shapes',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 13',
      Date: '22-Jan-23',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 14',
      Date: '5-Feb-23',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 7 AICBTS - 15',
      Date: '19-Feb-23',
      date_time: '(Sun),  2:00PM- 3:00PM',
      Maths: 'Full Syllabus ',
    },
  ],
  CBSE_G8: [
    {
      test_name: 'CBSE Grade 8 AICBTS-1 ',
      Date: '22-May-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Rational Numbers',
      Science:
        'Force and Pressure Synthetic Fibres And Plastics Crop Production And Management',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-2',
      Date: '29-May-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Linear Equation in One Variable',
      Science:
        'Force and Pressure Synthetic Fibres And Plastics Crop Production And Management',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-3',
      Date: '12-Jun-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Understanding Quadrilaterals Practical Geometry',
      Science:
        'Friction                                                       Materials : Metals And Non Metals Microorganisms : Friend And Foe',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-4',
      Date: '26-Jun-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Data Handling',
      Science:
        'Friction                                                                      Materials : Metals And Non Metal Microorganisms : Friend And Foe',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-5',
      Date: '10-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Square and Square Roots Cubes and Cube Roots',
      Science:
        'Friction Materials : Metals And Non Metals  Microorganisms : Friend And Foe',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-6',
      Date: '24-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Comparing Quantities',
      Science: 'Sound Coal And Petroleum Conservation Of Plants And Animals',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-7',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Algebraic Expressions and Identities Visualising Solid Shapes',
      Science:
        'Chemical Effects of Current Coal And Petroleum Cell -Structure and Fuctions',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-8',
      Date: '14-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths:
        'Rational Numbers Linear Equations in One Variable Understanding Quadrilaterals',
      Science:
        'Force and Pressure Combustion and flame  Crop Production And Management',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-9',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Practical Geometry Square and Square Roots Cube and Cube Roots',
      Science:
        'Microorganisms : Friend And Foe Metals and non metals  Force and Pressure',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-10',
      Date: '28-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths:
        'Comparing Quantities Algebraic Expressions and Identities  Visualising Solid Shapes',
      Science: 'Friction Metals and non metals Microorganisms : Friend And Foe',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-11',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths:
        'Rational Numbers Linear Equations in One Variable Understanding Quadrilaterals Practical Geometry Square and Square Roots Cube and Cube Roots Comparing Quantities Comparing Quantities Algebraic Expressions and Identities Visualising Solid Shapes',
      Science: ' Friction Coal And Petroleum Cell -Structure and function',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-12',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Mensuration Exponents and Powers',
      Science:
        'Some Natural Phenomen  Chemical effects of current Reproduction Animals',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-13',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Direct and Inverse Proportions',
      Science:
        'Some Natural Phenomen  Chemical effects of current Reproduction Animals',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-14',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Factori(sat)ion',
      Science: 'Light Combustion And Flame Reaching The Age Adolescence',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-15',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Introduction to Graphs',
      Science: 'Light Combustion And Flame Reaching The Age Adolescence',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-16',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Playing with Numbers',
      Science: 'Light Combustion And Flame Pollution of Air and Water',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-17',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-18',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 8 AICBTS-19',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
  ],
  CBSE_G9: [
    {
      test_name: 'CBSE Grade 9 AICBTS-1 ',
      Date: '15-May-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Describing Motion Matter In Our Surroundings Fundamental unit of life',
      Maths: 'Number System',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-2',
      Date: '29-May-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Describing Motion Matter In Our Surroundings Fundamental unit of life Tissues',
      Maths: 'Polynomials',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-3',
      Date: '12-Jun-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Force and Law of Motion Is Matter Around Us Pure?  Tissues',
      Maths: 'Coordinate Geometry Linear Equations in two Variables',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-4',
      Date: '26-Jun-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Force and Law of Motion Is Matter Around Us Pure? Tissue',
      Maths: "Euclid's Geometry  ",
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-5',
      Date: '10-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Force and Law of Motion Is Matter Around Us Pure? Tissue',
      Maths: 'Line and Angles Triangles',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-6',
      Date: '24-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Gravitation Atoms And Molecules Diversity in Living organisms',
      Maths: 'Quadrilaterals',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-7',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Gravitation Atoms And Molecules Why do we fall ill?',
      Maths: ' Circles',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-8',
      Date: '14-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Motion Is matter around us Pure Fundamental unit of life',
      Maths:
        'Number System Polynomials Coordinate Geometry & Linear Equations in Two Variables',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-9',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Motion Is matter around us Pure  Fundamental unit of life',
      Maths:
        "Euclid's Geometry & Lines and Angles revisison  Triangle Revision",
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-10',
      Date: '28-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Tissues Force and Law of Motion Is matter around us Pure ',
      Maths: 'Quadrilaterals Circle',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-11',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Force and Law of Motion Is matter around us Pure  Matter and surroundings  States of matter  Diversity in Living organisms',
      Maths:
        "Number System Polynomials Coordinate Geometry & Linear Equations in Two Variables Euclid's Geometry & Lines and Angles Triangle  Quadrilaterals Quadrilaterals Circles",
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-12',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Work and Energy Atoms And Molecules Why do we fall ill?',
      Maths: 'Circles Constructions',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-13',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Work and Energy Atoms And Molecules Why do we fall ill?',
      Maths: 'Herons Formula',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-14',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Work and Energy Atoms And Molecules Improvement In Food resources',
      Maths: 'Surface areas and Volmues',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-15',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Sound Structure Of The Atom Improvement In Food resources',
      Maths: 'Surface areas and Volmues',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-16',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Sound Structure Of The Atom Natural resources',
      Maths: 'Statistics',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-17',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Sound Structure Of The Atom Natural resources',
      Maths: 'Probability',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-18',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-19',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-20',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 9 AICBTS-21',
      Date: '12-Mar-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Full Syllabus ',
    },
  ],
  CBSE_G10: [
    {
      test_name: 'CBSE Grade 10th AICBTS-1 ',
      Date: '15-May-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Reflection Of Light Chemical Reactions And Equations Life Processes',
      Maths: 'Real Numbers Polynomials',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-2',
      Date: '29-May-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Refraction Of Light  Chemical Reactions And Equations Acids, Bases And Salts Life Processes',
      Maths: 'Pair Of Linear Equations In Two Variable',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-3',
      Date: '12-Jun-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'The Human Eye And The Colourful World Acids, Bases And Salts Life Processes',
      Maths: 'Pair Of Linear Equations In Two Variables  #Quadratic Equations',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-4',
      Date: '26-Jun-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'The Human Eye And The Colourful World Acids, Bases And Salts Life Processes',
      Maths: 'Arithmetic Progressions Coordinate Geometry',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-5',
      Date: '10-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'The Human Eye And The Colourful World Acids, Bases And Salts Life Processes',
      Maths: 'Coordinate Geometry Triangle',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-6',
      Date: '24-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Electricity Metals And Non-Metals Control And Coordination',
      Maths: 'Triangle-5 Trigonometry',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-7',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Electricity Metals And Non-Metals Control And Coordination How Do Organisms Reproduce ?',
      Maths: 'Some Applications Of Trigonometry Circles',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-8',
      Date: '14-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Light: Reflection Chemical reaction and equation Life Processes (Nutrition , Respiration)',
      Maths:
        'Real Numbers Polynomials Pair Of Linear Equations In Two Variables',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-9',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Light: Refraction Metals and non metals Life Processes',
      Maths: 'Quadratic Equations  Arithmetic Progression ',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-10',
      Date: '28-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Light-Reflection and Refraction Metals and non metals  Life Processes',
      Maths:
        'Coordinate Geometry Triangle Trigonometry Application of Trigonometry Circles',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-11',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'The Human Eye And The Colourful World -       Acids bases and salts  Control And Coordination',
      Maths:
        'Real Numbers Polynomials Pair Of Linear Equations In Two Variables Quadratic Equations Arithmetic Progression Coordinate Geometry Triangle  Introduction To Trigonometry Application of Trigonometry Circles',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-12',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Electricity Carbon And Its Compounds How Do Organisms Reproduce ?',
      Maths: 'Circles  Areas Related To Circles',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-13',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Magnetic Effects Of Electric Current Carbon And Its Compounds Heredity And Evolution',
      Maths: 'Surface Areas And Volumes',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-14',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Magnetic Effects Of Electric Current Carbon And Its Compounds Heredity And Evolution',
      Maths: 'Statistics',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-15',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Sources Of Energy Periodic Classification Of Elements Our Environment',
      Maths: 'Probability',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-16',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Sources Of Energy Periodic Classification Of Elements Sustainable Management Of Natural Resources',
      Maths: 'Area Related to Circle Surface Area Volume',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-17',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science:
        'Magnetic Effects Of Electric Current Sources Of Energy Periodic Classification Of Elements Sustainable Management Of Natural Resources',
      Maths: 'Circle Statistics Probability',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-18',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Full Chapter',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-19',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Full Chapter',
    },
    {
      test_name: 'CBSE Grade 10th AICBTS-20',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Science: 'Full Chapter',
    },
  ],
  CBSE_G11: [
    {
      test_name: 'CBSE Grade 11 AICBTS-1',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Physical World Units and Measurement',
      Chem: 'Some Basic Concepts of Chemistry',
      Bio: 'Living World #Biological Classification  #Plant Kingdom #Animal Kingdom',
      Maths: 'Fundametals of mathematics #Sets #Relations',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-2',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Motion in a straight line #Motion in a Plane',
      Chem: 'Structure of Atom ',
      Bio: 'Morphology of Flowering Plants #Anatomy of flowering plants',
      Maths: 'Functions #Trigonometric Functions',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-3',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Laws of Motion #Work, #Energy and #Power',
      Chem: 'Classification of Elements and Periodicity in Properties Chemical bonding',
      Bio: 'Cell : The Unit of Life  #Cell Cycle and Cell Division',
      Maths: 'Trigonometric Functions #Quadratic equations',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-4',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'System of Particles and Rotational Motion ',
      Chem: 'Thermodynamics',
      Bio: 'Photosynthesis in higher plants #Structural organi(sat)ion in animal',
      Maths: 'Complex numbers #Linear inequalities',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-5',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Gravitation',
      Chem: 'Equilibrium',
      Bio: ' Respiration in plants #Biomolecules',
      Maths: 'Permutations and Combinations #Binomial theorem',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-6',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Mechanical Properties of Solids #Mechanical Properties of Fluids ',
      Chem: 'Redox Reaction',
      Bio: 'Plant growth and development',
      Maths: 'Sequences and Series',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-7',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Thermal Properties of Matter ',
      Chem: 'Organic Chemistry- Some basic principles and techniques',
      Bio: 'Body fluids and circulation #Excretory products and their Elimination',
      Maths: 'Coordinate geometry (2D)',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-8',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Kinetic Theory Thermodynamics',
      Chem: 'Organic Chemistry- Some basic principles and techniques',
      Bio: 'Locomotion and movement #Neural control and coordination',
      Maths: 'Circles# Conic Section #Three Dimensional Geometry',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-9',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Oscillation Waves',
      Chem: 'Hydrocarbons',
      Bio: 'Chemical coordination and integration',
      Maths: 'Limits #Derivatives #Statistics #Probability',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-10',
      Date: '12-Mar-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-11',
      Date: '26-Mar-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Full Syllabus ',
    },
    {
      test_name: 'CBSE Grade 11 AICBTS-12',
      Date: '9-Apr-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Phy: 'Full Syllabus ',
    },
  ],
  CBSE_G12: [
    {
      test_name: 'CBSE Grade 12 AICBTS-1 ',
      Date: '15-May-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Electric Charges and Fields',
      Chem: 'Solutions',
      Maths: 'Relations and Functions ',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-2',
      Date: '29-May-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: ' Electrostatic Potential and Capacitance',
      Chem: 'Solutions',
      Maths: 'Inverse Trigonometric Functions',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-3',
      Date: '5-Jun-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: ' Electrostatic Potential and Capacitance',
      Chem: 'Solutions',
      Maths: 'Matrices',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-4',
      Date: '19-Jun-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: ' Electrostatic Potential and Capacitance',
      Chem: 'Electrochemistry',
      Maths: 'Matrices',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-5',
      Date: '3-Jul-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Current Electricity',
      Chem: 'Electrochemistry',
      Maths: 'Determinants',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-6',
      Date: '17-Jul-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Current Electricity',
      Chem: 'Electrochemistry',
      Maths: 'Determinants',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-7',
      Date: '31-Jul-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Moving Charges and magnetism',
      Chem: 'Electrochemistry',
      Maths: 'Continuity and Differentiability',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-8',
      Date: '14-Aug-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Moving Charges and magnetism',
      Chem: 'Chemical kinetics',
      Maths: 'Continuity and Differentiability',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-9',
      Date: '28-Aug-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Magnetism and Matter',
      Chem: 'Chemical kinetics',
      Maths: 'Applications of Derivatives',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-10',
      Date: '11-Sep-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Magnetism and Matter',
      Chem: 'Chemical kinetics',
      Maths: 'Applications of Derivatives',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-11',
      Date: '25-Sep-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Electromagnetic induction',
      Chem: 'd- and f- block elements',
      Maths: 'Applications of Derivatives',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-12',
      Date: '9-Oct-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Electromagnetic induction',
      Chem: 'd- and f- block elements',
      Maths: 'Integrals',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-13',
      Date: '23-Oct-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Alternating Current',
      Chem: 'd- and f- block elements',
      Maths: 'Integrals',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-14',
      Date: '6-Nov-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Electromagnetic Waves',
      Chem: 'Coordination Compounds ',
      Maths: 'Integrals',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-15',
      Date: '20-Nov-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Ray Optics and Optical Instruments',
      Chem: 'Haloalkanes and Haloarenes ',
      Maths: 'Integrals, Application of Integrals',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-16',
      Date: '4-Dec-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Ray Optics and Optical Instruments',
      Chem: 'Alcohols,Phenols and Ethers',
      Maths: 'Differential Equations',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-17',
      Date: '18-Dec-22',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Wave optics',
      Chem: 'Aldehyde,ketones and carboxylic acids',
      Maths: 'Vectors',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-18',
      Date: '1-Jan-23',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Wave optics #Dual Nature of Matter and Radiation',
      Chem: 'Aldehyde,ketones and carboxylic acids',
      Maths: '3-D Geometry',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-19',
      Date: '15-Jan-23',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Atoms #Nuclei',
      Chem: 'Amines',
      Maths: '3-D Geometry and LPP',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-20',
      Date: '29-Jan-23',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Semiconductor Electronics: Materials, Devices and Simple Circuits',
      Chem: 'Biomolecules',
      Maths: 'Probability',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-21',
      Date: '12-Feb-23',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-22',
      Date: '26-Feb-23',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-23',
      Date: '12-Mar-23',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Syllabus of XII',
    },
    {
      test_name: 'CBSE Grade 12 AICBTS-24',
      Date: '26-Mar-23',
      date_time: '(Sun), 2pm to 4:30pm',
      Phy: 'Syllabus of XII',
    },
  ],
  Foundation_G9: [
    {
      test_name_NEET: 'NEET Test Name',
      test_name_JEE: 'JEE Test Name',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-1',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-1',
      Date: '24-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Number Systems',
      Phy: 'Motion Basic Maths (vectors)',
      Chem: 'Matter In Our Surroundings',
      Bio: 'Fundamental unit of life',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-2',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-2',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Polynomials',
      Phy: 'Force and Law of Motion',
      Chem: 'Is Matter Around Us Pure?',

      Bio: 'Fundamental unit of life',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-3',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-3',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Coordinate Geometry',
      Phy: 'Force and Law of Motion',
      Chem: 'Is Matter Around Us Pure?',
      Bio: 'Fundamental unit of life',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-4',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-4',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Linear Equations in Two Variables',
      Phy: 'Gravitation',
      Chem: 'Is Matter Around Us Pure?',
      Bio: 'Tissues',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-5',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-5',
      Date: '18-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Linear Equations in Two Variables Euclid’s Geometry',
      Phy: 'Fluid Mechanics',
      Chem: 'Atoms And Molecules',
      Bio: 'Tissues',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-6',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-6',
      Date: '1-Oct-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Lines and Angles',
      Phy: 'Work Power Energy',
      Chem: 'Atoms And Molecules',
      Bio: 'Tissues',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-6',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-6',
      Date: '2-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Lines and Angles',
      Phy: 'Work Power Energy',
      Chem: 'Atoms And Molecules',
      Bio: 'Tissues',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-7',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-7',
      Date: '15-Oct-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Triangles',
      Phy: 'Work Power Energy',
      Chem: 'Atoms And Molecules',
      Bio: 'Diversity In Living Organisms',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-7',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-7',
      Date: '16-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Triangles',
      Phy: 'Work Power Energy',
      Chem: 'Atoms And Molecules',
      Bio: 'Diversity In Living Organisms',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-8',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-8',
      Date: '29-Oct-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Quadrilaterals',
      Phy: 'Sound',
      Chem: 'Structure Of The Atom',
      Bio: 'Diversity In Living Organisms',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-8',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-8',
      Date: '30-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Quadrilaterals',
      Phy: 'Sound',
      Chem: 'Structure Of The Atom',
      Bio: 'Diversity In Living Organisms',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-9',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-9',
      Date: '12-Nov-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Areas of Parallelograms and Triangles  Circles',
      Phy: 'Sound',
      Chem: 'Structure Of The Atom',
      Bio: 'Why Do We Fall Ill?',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-9',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-9',
      Date: '13-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Areas of Parallelograms and Triangles  Circles',
      Phy: 'Sound',
      Chem: 'Structure Of The Atom',
      Bio: 'Why Do We Fall Ill?',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-10',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-10',
      Date: '26-Nov-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: ' Heron’s Formula  #Surface Areas and Volumes',
      Phy: 'Force and Law of Motion Gravitation',
      Chem: 'Structure Of The Atom',
      Bio: 'Improvement In Food Resources',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-10',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-10',
      Date: '27-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: ' Heron’s Formula  #Surface Areas and Volumes',
      Phy: 'Force and Law of Motion Gravitation',
      Chem: 'Structure Of The Atom',
      Bio: 'Improvement In Food Resources',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-11',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-11',
      Date: '10-Dec-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: ' Statistics',
      Phy: 'Fluid Mechanics #Work #Power #Energy',
      Chem: 'Chemical Bonding',
      Bio: 'Improvement In Food Resources',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-11',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-11',
      Date: '11-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: ' Statistics',
      Phy: 'Fluid Mechanics #Work #Power #Energy',
      Chem: 'Chemical Bonding',
      Bio: 'Improvement In Food Resources',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-12',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-12',
      Date: '24-Dec-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: ' Probability',
      Phy: 'Sound',
      Chem: 'Carbon and its Compound',
      Bio: 'Natural Resources',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-12',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-12',
      Date: '25-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: ' Probability',
      Phy: 'Sound',
      Chem: 'Carbon and its Compound',
      Bio: 'Natural Resources',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-13',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-13',
      Date: '7-Jan-23',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-13',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-13',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-14',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-14',
      Date: '21-Jan-23',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-14',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-14',
      Date: '22-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-15',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-15',
      Date: '4-Feb-23',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name: 'NEET Foundation Grade 9 ILTS-15',
      test_name_JEE: 'JEE Foundation Grade 9 ILTS-15',
      Date: '5-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
  ],
  Foundation_G10: [
    {
      test_name_NEET: 'NEET Test Name',
      test_name_JEE: 'JEE Test Name',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-1',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-1',
      Date: '24-Jul-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Real Numbers  #Polynomials and Rational Expression',
      Phy: 'Light-Reflection',
      Chem: 'Chemical Reactions And Equations',
      Bio: 'Life Processes',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-2',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-2',
      Date: '7-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Linear Equation in Two Variable',
      Phy: 'Light-Refraction',
      Chem: 'Chemical Reactions And Equations',
      Bio: 'Life Processes',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-3',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-3',
      Date: '21-Aug-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Quadratic Equations and Inequalities',
      Phy: 'The Human Eye And The Colourful World',
      Chem: 'Acids, Bases And Salts',
      Bio: 'Life Processes',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-4',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-4',
      Date: '4-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Progressions',
      Phy: 'The Human Eye And The Colourful World',
      Chem: 'Acids, Bases And Salts',
      Bio: 'Control And Coordination',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-5',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-5',
      Date: '18-Sep-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Coordinate Geometry',
      Phy: 'Electricity',
      Chem: 'Metals And Non-Metals',
      Bio: 'Control And Coordination',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-6',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-6',
      Date: '1-Oct-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Geometry',
      Phy: 'Electricity',
      Chem: 'Metals And Non-Metals',
      Bio: 'Control And Coordination',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-6',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-6',
      Date: '2-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Geometry',
      Phy: 'Electricity',
      Chem: 'Metals And Non-Metals',
      Bio: 'Control And Coordination',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-7',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-7',
      Date: '15-Oct-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Geometry',
      Phy: 'Magnetic Effects Of Electric Current',
      Chem: 'Carbon And Its Compounds',
      Bio: 'How Do Organisms Reproduce ?',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-7',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-7',
      Date: '16-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Geometry',
      Phy: 'Magnetic Effects Of Electric Current',
      Chem: 'Carbon And Its Compounds',
      Bio: 'How Do Organisms Reproduce ?',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-8',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-8',
      Date: '29-Oct-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Trigonometry',
      Phy: 'Magnetic Effects Of Electric Current',
      Chem: 'Carbon And Its Compounds',
      Bio: 'How Do Organisms Reproduce ?',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-8',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-8',
      Date: '30-Oct-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Trigonometry',
      Phy: 'Magnetic Effects Of Electric Current',
      Chem: 'Carbon And Its Compounds',
      Bio: 'How Do Organisms Reproduce ?',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-9',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-9',
      Date: '12-Nov-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: ' Set, Relation and Function(Sets only )',
      Phy: 'Magnetic Effects Of Electric Current',
      Chem: 'Periodic Classification Of Elements',
      Bio: 'Heredity And Evolution',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-9',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-9',
      Date: '13-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Set, Relation and Function(Relation )',
      Phy: 'Magnetic Effects Of Electric Current',
      Chem: 'Periodic Classification Of Elements',
      Bio: 'Heredity And Evolution',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-10',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-10',
      Date: '26-Nov-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Set, Relation and Function(Function only)',
      Phy: 'Sources Of Energy',
      Chem: 'PERIODICITY IN PROPERTIES OF ELEMENTS',
      Bio: 'Heredity And Evolution',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-10',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-10',
      Date: '27-Nov-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Set, Relation and Function(Limits only )',
      Phy: 'Sources Of Energy',
      Chem: 'PERIODICITY IN PROPERTIES OF ELEMENTS',
      Bio: 'Heredity And Evolution',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-11',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-11',
      Date: '10-Dec-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Mensuration',
      Phy: 'Sources Of Energy',
      Chem: 'Chemical Bonding',
      Bio: 'Our Environment',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-11',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-11',
      Date: '11-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Mensuration',
      Phy: 'Sources Of Energy',
      Chem: 'Chemical Bonding',
      Bio: 'Our Environment',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-12',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-12',
      Date: '24-Dec-22',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Statistics and Probability',
      Phy: 'Magnetic Effects Of Electric Current Sources Of Energy',
      Chem: 'PERIODICITY IN PROPERTIES OF ELEMENTS Chemical Bonding',
      Bio: 'Sustainable Management Of Natural Resources',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-12',
      test_name_JEE: 'JEE Foundation Grade 10 ILTS-12',
      Date: '25-Dec-22',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Statistics and Probability',
      Phy: 'Magnetic Effects Of Electric Current #Sources Of Energy',
      Chem: 'PERIODICITY IN PROPERTIES OF ELEMENTS #Chemical Bonding',
      Bio: 'Sustainable Management Of Natural Resources',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-13',
      test_name_JEE: 'NEET Foundation Grade 10 ILTS-13',
      Date: '7-Jan-23',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-13',
      test_name_JEE: 'NEET Foundation Grade 10 ILTS-13',
      Date: '8-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-14',
      test_name_JEE: 'NEET Foundation Grade 10 ILTS-14',
      Date: '21-Jan-23',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-14',
      test_name_JEE: 'NEET Foundation Grade 10 ILTS-14',
      Date: '22-Jan-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-15',
      test_name_JEE: 'NEET Foundation Grade 10 ILTS-15',
      Date: '4-Feb-23',
      date_time: '(Sat), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
    {
      test_name_NEET: 'NEET Foundation Grade 10 ILTS-15',
      test_name_JEE: 'NEET Foundation Grade 10 ILTS-15',
      Date: '5-Feb-23',
      date_time: '(Sun), 2pm to 3:30pm',
      Maths: 'Full Syllabus ',
    },
  ],
};

export const basic_propackage = {
  amount :3999
}

export const productTypes = {
  "liveclasses": "liveclasses",
  "recordedcourses": "recordedcourse",
  "hardware": "hardware",
  "doubts": "doubts",
  "assessments": "assessment",
  "selflearn": "selflearn",
  // extra(not components)
  "score": "score",
  "books": "books"
}

export const CUETExamtypes = [
  '52d43478-65be-11ed-9022-0242ac120002',
  'a851d6b8-65bd-11ed-9022-0242ac120002',
  'd0e5c8fa-65bd-11ed-9022-0242ac120002',
  '0ed6411c-65be-11ed-9022-0242ac120002',
  '1eda50ee-65be-11ed-9022-0242ac120002',
  '337edf2e-65be-11ed-9022-0242ac120002',
  '41d60246-65be-11ed-9022-0242ac120002',
  '6649791e-65be-11ed-9022-0242ac120002',
];

export const ZeroDiscountForOptimization: string = "developercode";
export const ISDCodes = [ 
  {
    countryCode: '+91',
    countryName: 'INDIA',
    selected: true
  },
  {
    countryCode: '+977',
    countryName: 'NEPAL',
    selected: false
  }
]

export const INDIAN_ISD_CODE = '+91';
export const NEPAL_ISD_CODE = '+977';
export const TRENDING = 'Trending';
export const RECOMMENDED = 'Recommended';
export const ILSHORTS = 'ILShorts';
export const PUZZLES = 'Puzzles';
export const TRENDING_VIDEOS_THIS_WEEK = "Trending videos this week";
export const RECOMMENDED_VIDEOS = "Recommended videos";
export const INFINITY_SHORTS = "Infinity Shorts";
export const QUESTION_NOTAVAILABLE = "QuestionNotAvailable"


export const subscriptionshortcode =  [
  {
    "name": "TIMEBOUND",
    "product_type": "Assessment",
    "Short": "A-TMB"
  },
  {
    "name": "MOCKTEST",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "PREVIOUSYEAR",
    "product_type": "Assessment",
    "Short": "A-PYP"
  },
  {
    "name": "Doubts",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Free Masterclasses",
    "product_type": "liveclasses",
    "Short": "A-FMC"
  },
  {
    "name": "Live Classes - NEET 2023 Full course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "JEE 2023 Full course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Free Masterclasses on the platform",
    "product_type": "liveclasses",
    "Short": "A-FMC"
  },
  {
    "name": "Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Live Classes - NEET 2022 Repeater Full course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Regi mock",
    "product_type": "LiveClass",
    "Short": "MSC"
  },
  {
    "name": "Live Classes - NEET 2022 Full course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - JEE 2022 Crash course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Ask 10 doubts on Live Chat",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Resolve doubts 24/7",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Ask Unlimited doubts on Live Chat",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Ask 1 doubts on Live Chat",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "SCORE Grade 3 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE Grade 4 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE Grade 5 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE Grade 6 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE Grade 7 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE Grade 8 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE Grade 9 Foundation NEET Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE Grade 9 Foundation JEE Main Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE Grade 10 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 10 JEE Main Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 11 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 11 JEE Main Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 12 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 12 JEE Main Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 12 JEE Advanced Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 13 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 13 JEE Main Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE Grade 13 JEE Advanced Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Previous Year Papers",
    "product_type": "Assessment",
    "Short": "A-PYP"
  },
  {
    "name": "Live Classes - JEE Main 2022 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 8 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Doubts App",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Live Classes - CBSE Grade 9 Term 2 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 10 Term 2 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 11 Term 2 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 12 Term 2 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - NEET Grade 11 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - JEE Grade 11 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes -NEET 2023 Grade 12 Full course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - JEE 2023 Grade 12 Full course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes -NEET 2022 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 8 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 9 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 10 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 11 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 12 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - NEET 2022 Revision course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - JEE Main 2022 Revision course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Ask 50 doubts on Live Chat",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Live Classes - NEET Foundation Grade 9 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - NEET Foundation Grade 10 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - JEE Foundation Grade 9 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - JEE Foundation Grade 10 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "RAPDailyTest",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "RAPTimeBound",
    "product_type": "Assessment",
    "Short": "A-TMB"
  },
  {
    "name": "Live Classes - NEET 2022 Rank Assurance Program",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Doubts Resolution",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Self-learn Videos",
    "product_type": "selflearn",
    "Short": "SL-Videos"
  },
  {
    "name": "Self-learn Flashcards",
    "product_type": "selflearn",
    "Short": "SL-Flashcards"
  },
  {
    "name": "Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL-ADP"
  },
  {
    "name": "Self-learn Stories",
    "product_type": "selflearn",
    "Short": "SL-Stories"
  },
  {
    "name": "Live Classes - JEE 2022 Rapid Revision Ranker",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 6 Maths Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 6 Science Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 7 Maths Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 7 Science Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Mock Test",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Free Masterclass",
    "product_type": "Assessment",
    "Short": "A-FMC"
  },
  {
    "name": "Physical Classroom",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "Self Learn Videos",
    "product_type": "Assessment",
    "Short": "SL-Videos"
  },
  {
    "name": "Self Learn Flashcards",
    "product_type": "Assessment",
    "Short": "SL-Flashcards"
  },
  {
    "name": "Adaptive Practice",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "Physical Books",
    "product_type": "Assessment",
    "Short": "HAR-Books"
  },
  {
    "name": "JEE 2023 Rank Assurance Program",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "NEET 2023 Rank Assurance Program",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Self-learn Elessons",
    "product_type": "selflearn",
    "Short": "SL-ELessons"
  },
  {
    "name": "Reserve your seat in the RAP @ Rs 499",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "Up to 50 % scholarship on course fees",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "RResult-oriented coaching by rank-producing faculty",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "Proven success of rank assurance programme",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "540 hours of live classes",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "3 hours of classes every day",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "Mind maps & flowcharts",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "Memorising tricks & more",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "SCORE (Online) Grade 1 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Online) Grade 2 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Online) Grade 3 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Online) Grade 4 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Online) Grade 5 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Online) Grade 6 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE (Online) Grade 7 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE (Online) Grade 8 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE (Online) Grade 9 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 9 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 10 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 10 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 11 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 11 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 12 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 12 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 13 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Online) Grade 13 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (Offline) Grade 1 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Offline) Grade 2 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Offline) Grade 3 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (Offline) Grade 4 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (offline) Grade 5 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "SCORE (offline) Grade 6 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE (offline) Grade 7 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE (offline) Grade 8 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "SCORE (offline) Grade 9 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 9 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 10 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 10 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 11 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 11 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 12 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 12 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 13 NEET Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "SCORE (offline) Grade 13 JEE Mains Test",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Live Classes - JEE 2024 Grade 11 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": " Grade 11 - Self Learn Videos,Flashcards,Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": " Grade 11 - Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": " Grade 11 - Previous Year Papers",
    "product_type": "Assessment",
    "Short": "A-PYP"
  },
  {
    "name": " Grade 11 - Instant Doubts Resolution",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Live Classes - Grade 12 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Grade 12 -  Self Learn Videos, Flashcards,Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Grade 12 - Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Grade 12 - Previous Year Papers",
    "product_type": "Assessment",
    "Short": "A-PYP"
  },
  {
    "name": "Grade 12 - Instant Doubts Resolution",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Live Classes - NEET 2024 Grade 11 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Grade 11 - Self Learn Videos, Flashcards And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Grade 11 - Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Grade 11 - Previous Year Papers",
    "product_type": "Assessment",
    "Short": "A-PYP"
  },
  {
    "name": "Grade 11 - Instant Doubts Resolution",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Grade 12 - Self Learn Videos, Flashcards And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Live Classes - Foundation Grade 10",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Self Learn Videos, Flashcards And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": " Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "TIMEBOUND",
    "product_type": "Assessment",
    "Short": "A-TMB"
  },
  {
    "name": "Instant Doubts Resolution",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": " Instant Doubts Resolution",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": " Self Learn Videos, Flashcards And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Live Classes - Foundation Grade 9",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "  Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Grade 10 - Self Learn Videos, Flashcards And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Grade 10 - Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Grade 10 - Instant Doubts Resolution",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "Change of SCORE package (Online) Grade 1 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (Online) Grade 2 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (Online) Grade 3 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (Online) Grade 4 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (Online) Grade 5 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (Online) Grade 6 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "Change of SCORE package (Online) Grade 7 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "Change of SCORE package (Online) Grade 8 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "Change of SCORE package (Online) Grade 9 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 9 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 10 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 10 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 11 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 11 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 12 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 12 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 13 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Online) Grade 13 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (Offline) Grade 1 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (offline) Grade 2 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (offline) Grade 3 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (offline) Grade 4 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (offline) Grade 5 Aptitude Test",
    "product_type": "Assessment",
    "Short": "A-APT"
  },
  {
    "name": "Change of SCORE package (offline) Grade 6 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "Change of SCORE package (offline) Grade 7 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "Change of SCORE package (offline) Grade 8 Foundation Test",
    "product_type": "Assessment",
    "Short": "A-FND"
  },
  {
    "name": "Change of SCORE package (offline) Grade 9 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 9 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 10 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 10 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 11 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 11 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 12 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 12 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 13 NEET",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Change of SCORE package (offline) Grade 13 JEE Main",
    "product_type": "Assessment",
    "Short": "A-SCO"
  },
  {
    "name": "Self Learn Elessons",
    "product_type": "selflearn",
    "Short": "SL-ELessons"
  },
  {
    "name": "Live Classes - CBSE Grade 9 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 10 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - CBSE Grade 12 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - NEET Foundation Grade 9 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - JEE Foundation Grade 9 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - NEET Foundation Grade 10 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Live Classes - JEE Foundation Grade 10 Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "Self Learn Flashcards",
    "product_type": "selflearn",
    "Short": "SL-Flashcards"
  },
  {
    "name": "Self Learn Videos",
    "product_type": "selflearn",
    "Short": "SL-Videos"
  },
  {
    "name": "Self Learn Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL-ADP"
  },
  {
    "name": "Live Classes - NEET 2023 Rank Assurance Program",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Doubts",
    "product_type": "Assessment",
    "Short": "DBT"
  },
  {
    "name": "Live Classes - JEE 2023 Rank Assurance Program",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "31 Ranker Series Books",
    "product_type": "Hardware",
    "Short": "HAR-Books"
  },
  {
    "name": "34 Grade 11 Ranker Series Books",
    "product_type": "Hardware",
    "Short": "HAR-Books"
  },
  {
    "name": "29 Grade 12 Ranker Series Books",
    "product_type": "Hardware",
    "Short": "HAR-Books"
  },
  {
    "name": "36 Grade 12 Ranker Series Books",
    "product_type": "Hardware",
    "Short": "HAR-Books"
  },
  {
    "name": "27 Grade 13 Achiever Series Books",
    "product_type": "Hardware",
    "Short": "HAR-Books"
  },
  {
    "name": "44 Grade 13 Achiever Series Books",
    "product_type": "Hardware",
    "Short": "HAR-Books"
  },
  {
    "name": "Live Classes - CUET 2023 Masterclass Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "41d60246-65be-11ed-9022-0242ac120002",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "337edf2e-65be-11ed-9022-0242ac120002",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "d0e5c8fa-65bd-11ed-9022-0242ac120002",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "a851d6b8-65bd-11ed-9022-0242ac120002",
    "product_type": "Assessment",
    "Short": "MSC"
  },
  {
    "name": "31 Grade 11 Ranker Series Books",
    "product_type": "Hardware",
    "Short": "HAR-Books"
  },
  {
    "name": "Grade 8 - Self Learn Videos, E-lessons And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Grade 8 - Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Grade 8 - Instant Doubts Resolution",
    "product_type": "Assessment",
    "Short": "DBT"
  },
  {
    "name": "Live Classes - Grade 9 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Grade 9 - Self Learn Videos, E-lessons And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Grade 9 - Mock tests",
    "product_type": "Assessment",
    "Short": "A-MCT"
  },
  {
    "name": "Grade 9 - Instant Doubts Resolution",
    "product_type": "Assessment",
    "Short": "DBT"
  },
  {
    "name": "Live Classes - Grade 10 Full Course",
    "product_type": "liveclasses",
    "Short": "LC-FullCourse"
  },
  {
    "name": "Grade 10 - Self Learn Videos,E-lessons And Adaptive Practice",
    "product_type": "selflearn",
    "Short": "SL"
  },
  {
    "name": "Grade 10 - Instant Doubts Resolution",
    "product_type": "Assessment",
    "Short": "DBT"
  },
  {
    "name": "JEE 2023 Rapid Revision Recorded Course",
    "product_type": "recordedCourse",
    "Short": "RC"
  },
  {
    "name": "NEET 2023 Rapid Revision Recorded Course",
    "product_type": "recordedCourse",
    "Short": "RC"
  },
  {
    "name": "JEE 2023 Revision Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": "NEET 2023 Revision Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  },
  {
    "name": " Doubts",
    "product_type": "Doubts",
    "Short": "DBT"
  },
  {
    "name": "NEET 2023 RAP Crash Course",
    "product_type": "liveclasses",
    "Short": "LC-CrashCourse"
  }
]
export const scoreExamData = [
  {
      "grade": 3,
      "exam":"APTITUDETEST",
      "examtype":"APTITUDE TEST",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 3 Aptitude Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 3 Aptitude Test",
      "marks":"60",
      "duration":"60"
  },
  {
      "grade": 4,
      "exam":"APTITUDETEST",
      "examtype":"APTITUDE TEST",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 4 Aptitude Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 4 Aptitude Test",
      "marks":"60",
      "duration":"60"
  },
  {
      "grade": 5,
      "exam":"APTITUDETEST",
      "examtype":"APTITUDE TEST",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 5 Aptitude Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 5 Aptitude Test",
      "marks":"60",
      "duration":"60"
  },
  {
      "grade": 6,
      "exam":"FOUNDATIONTEST",
      "examtype":"FOUNDATION TEST",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 6 Foundation Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 6 Foundation Test",
      "marks":"50",
      "duration":"70"
  },
  {
      "grade": 7,
      "exam":"FOUNDATIONTEST",
      "examtype":"FOUNDATION TEST",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 7 Foundation Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 7 Foundation Test",
      "marks":"50",
      "duration":"70"
  },
  {
      "grade": 8,
      "exam":"FOUNDATIONTEST",
      "examtype":"FOUNDATION TEST",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 8 Foundation Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 8 Foundation Test",
      "marks":"50",
      "duration":"70"
  },
  {
      "grade": 9,
      "exam":"JEEMAIN",
      "examtype":"IIT / JEE ADVANCED",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 9 IIT Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 9 IIT Test",
      "marks":"50",
      "duration":"77"
  },
  {
      "grade": 10,
      "exam":"IIT / JEE ADVANCED",
      "examtype":"JEE",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 10 IIT Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 10 IIT Test",
      "marks":"50",
      "duration":"75"
  },
  {
      "grade": 11,
      "exam":"IIT / JEE ADVANCED",
      "examtype":"JEE",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 11 IIT Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 11 IIT Test",
      "marks":"50",
      "duration":"75"
  },
  {
      "grade": 12,
      "exam":"IIT / JEE ADVANCED",
      "examtype":"JEE",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 12 IIT Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 12 IIT Test",
      "marks":"50",
      "duration":"75"
  },
  {
      "grade": 9,
      "exam":"NEET",
      "examtype":"NEET",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 12 NEET Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 12 NEET Test",
      "marks":"50",
      "duration":"75"
  },
  {
      "grade": 10,
      "exam":"NEET",
      "examtype":"NEET",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 10 NEET Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 10 NEET Test",
      "marks":"50",
      "duration":"75"
  },
  {
      "grade": 11,
      "exam":"NEET",
      "examtype":"NEET",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 11 NEET Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 11 NEET Test",
      "marks":"50",
      "duration":"75"
  },
  {
      "grade": 12,
      "exam":"NEET",
      "examtype":"NEET",
      "testype":"TIMEBOUND",
      "examname":"SCORE 2023 (Online) Grade 12 NEET Test",
      "offlneExamName":"SCORE 2023 (Offline) Grade 12 NEET Test",
      "marks":"50",
      "duration":"75"
  }
]

export const cmsMapKeyForReportTemplates = {
  "JEE Advanced":'jeeAdvance',
  "NEET":'neet',
  "JEE Main":'jeeMains',
  "RMO":'RMO',
  "IJSO":'IJSO',
}
export const timeboundTestTypesForRevamp = ['066697cf-709c-4c67-a0bb-e43feb0043d9', '51592ef8-8334-479f-8a91-7cfe809b7c04'];
export const MCTTestTypesForRevamp = ['5f9624f0-098c-41c6-999b-d847c7e4e3a3', '5d6fcff0-1000-45bb-b62a-d3d2b2bd3189',"066697cf-709c-4c67-a0bb-e43feb0043d9"];
export const timeboundExamsForRevamp = ['NEET', 'JEE Main', 'JEE Advanced', 'Foundation Test'];
export const timeboundForRMOAndIJSoForRevamp = ['RMO', 'IJSO'];
export const MCTExamsForRevamp = ["NEET", "JEE Main", "Foundation Test"];
export const gradesForRevamp = [8, 9, 10, 11, 12, 13];
export const gradesForRevampForRMOAndIJSO = [7, 8, 9, 10];



